/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { RoleName } from 'constants/constants';
import { ToolStandardEpdOptionModel } from 'types/tools/ToolStandardEpdOptionModel';
import { ToolVersionStandardEpdOptionModel } from 'types/tools/ToolVersionStandardEpdOptionModel';
import { BaseQueryParams, DepublishReasonType, DictionaryValue, Option, VerifierCompanyAddressModel } from 'types/types';
import { axiosInstance } from './api/apiCommon';
import { LcaXLValidationError } from 'types/lca-results/LcaXLValidationError';
import { PagedResult } from 'types/search-common/PagedResult';

export class BaseClient {
  transformOptions(options: RequestInit): Promise<RequestInit> {
    options.credentials = 'include';
    return Promise.resolve(options);
  }

  getOptions(): RequestInit {
    return {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };
  }

  getPostOptions(content: string): RequestInit {
    return {
      method: 'POST',
      body: content,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  getPutOptions(content: string): RequestInit {
    return {
      method: 'PUT',
      body: content,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  getPutOptionsNoAccept(content: string): RequestInit {
    return {
      method: 'PUT',
      body: content,
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  genericProcessGetAll<T>(response: Response): Promise<T> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <T>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<T>(<any>null);
  }

  // private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = <any>window;

  // genericGetById<T>(url_: string, id: string): Promise<T> {
  //     if (id === undefined || id === null)
  //         throw new Error("The parameter 'id' must be defined.");
  //     url_ = url_.replace("{id}", encodeURIComponent("" + id));
  //     url_ = url_.replace(/[?&]$/, "");

  //     let options_ = this.getOptions();

  //     return this.transformOptions(options_).then(transformedOptions_ => {
  //         return this.http.fetch(url_, transformedOptions_);
  //     }).then((_response: Response) => {
  //         return this.genericProcessGet<T>(_response);
  //     });
  // }

  genericProcessGet<T>(response: Response): Promise<T> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <T>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<T>(<any>null);
  }

  genericProcessCreate<T>(response: Response): Promise<T> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201 || status === 200) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 = _responseText === '' ? null : <T>JSON.parse(_responseText, this.jsonParseReviver);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<T>(<any>null);
  }

  genericProcessUpdate<T>(response: Response): Promise<T> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <T>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<T>(<any>null);
  }

  voidProcessPut(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  baseProcessUpdate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  baseProcessDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export interface IAccountsClient {
  getAll(companyId: string | null | undefined): Promise<AccountModel[]>;
  post(createAccountModel: CreateAccountModel): Promise<Account>;
  get(id: string): Promise<AccountModel>;
  put(id: string, updateAccountModel: UpdateAccountModel): Promise<void>;
  delete(id: string): Promise<void>;
  inviteUsers(roleName: string | null | undefined): Promise<AccountSummaryModel>;
}

export class AccountsClient extends BaseClient implements IAccountsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(companyId: string | null | undefined): Promise<AccountModel[]> {
    let url_ = this.baseUrl + '/api/v1/Accounts?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<AccountModel[]>(_response);
      });
  }

  post(createAccountModel: CreateAccountModel): Promise<Account> {
    let url_ = this.baseUrl + '/api/v1/Accounts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createAccountModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<Account>(_response);
      });
  }

  get(id: string): Promise<AccountModel> {
    let url_ = this.baseUrl + '/api/v1/Accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<AccountModel>(_response);
      });
  }

  put(id: string, updateAccountModel: UpdateAccountModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateAccountModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  inviteUsers(roleName: string | null | undefined): Promise<AccountSummaryModel> {
    let url_ = this.baseUrl + '/api/v1/Accounts/InviteUsers?';
    if (roleName !== undefined && roleName !== null) url_ += 'RoleName=' + encodeURIComponent('' + roleName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<AccountSummaryModel>(_response);
      });
  }
}

export class CollectionsClient extends BaseClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(companyId: string | undefined): Promise<CollectionModel[]> {
    let url_ = this.baseUrl + '/api/v1/Collections?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CollectionModel[]>(_response);
      });
  }

  async getAllEPDs(companyId: string, accountId: string): Promise<CollectionEPDModel[]> {
    const url = `${this.baseUrl}/api/v1/Collections/AllEPDs?companyId=${companyId}&accountId=${accountId}`;
    const response = await this.http.fetch(url, await this.transformOptions(this.getOptions()));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Collections/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  addCollectionEPD(addCollectionEPDModel: AddCollectionEPDModel): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/Collections/AddCollectionEPD';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(addCollectionEPDModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }

  removeCollectionEPD(id: string, epdId: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/Collections/{id}/RemoveEPD/{epdId}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (epdId === undefined || epdId === null) throw new Error("The parameter 'epdId' must be defined.");
    url_ = url_.replace('{epdId}', encodeURIComponent('' + epdId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveCollectionEPD(_response);
      });
  }

  protected processRemoveCollectionEPD(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(<any>null);
  }
}

export class CollectionsClientV2 extends BaseClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(companyId: string | undefined): Promise<CollectionDashboardModel[]> {
    let url_ = this.baseUrl + '/api/v2/CollectionsV2?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CollectionDashboardModel[]>(_response);
      });
  }

  async save(collectionModel: SaveCollectionModel): Promise<string> {
    const options = await this.transformOptions(this.getPostOptions(JSON.stringify(collectionModel)));
    const response = await this.http.fetch(`${this.baseUrl}/api/v2/CollectionsV2`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  publish(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/CollectionsV2/{id}/publish';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(id);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<boolean>(_response);
      });
  }

  depublish(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/CollectionsV2/{id}/depublish';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(id);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<boolean>(_response);
      });
  }

  get = async (id: string) => (await axiosInstance.get<CollectionModel>(`/api/v2/CollectionsV2/${id}`)).data;

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/CollectionsV2/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  addCollectionFile(
    collectionId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/CollectionsV2/AddCollectionFileV2';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (collectionId === null || collectionId === undefined) throw new Error("The parameter 'collectionId' cannot be null.");
    else content_.append('CollectionId', collectionId.toString());
    if (propertyName !== null && propertyName !== undefined) content_.append('PropertyName', propertyName.toString());
    if (newValue !== null && newValue !== undefined)
      content_.append('NewValue', newValue.data, newValue.fileName ? newValue.fileName : 'NewValue');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }
}

interface GetVerifiersParams {
  smartFilter?: string | null;
  companyId?: string | null;
  countryId?: string | null;
  isGlobalMarketplace?: boolean | null;
  epdVersionId?: string | null;
  verificationType?: VerificationType | null;
}

export interface ICompaniesClient {
  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    withMembership: boolean | undefined,
    countryId: string | null | undefined
  ): Promise<CompanyModel[]>;
  registerNew(createCompanyModel: CreateCompanyModel): Promise<string>;
  getLinkableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]>;
  getLicensees(companyId: string | undefined): Promise<LicenseeModel[]>;
  getDevelopers(
    smartFilter: string | null | undefined,
    companyId: string | null | undefined,
    countryId: string | null | undefined,
    epdVersionId: string | null | undefined
  ): Promise<DeveloperCompanyModel[]>;
  getVerifiers({
    smartFilter,
    companyId,
    countryId,
    isGlobalMarketplace,
    epdVersionId,
    verificationType,
  }: GetVerifiersParams): Promise<VerifierModel[]>;
  get(id: string): Promise<CompanyModel>;
  updateSettings(id: string, updateCompanySettingsModel: UpdateCompanySettingsModel): Promise<void>;
  updateInvoiceInfo(id: string, updateCompanyInvoiceInfoModel: UpdateCompanyInvoiceInfoModel): Promise<void>;
  delete(id: string): Promise<void>;
  updateCompanyProperty(updateCompanyPropertyModel: UpdateCompanyPropertyModel): Promise<CompanyModel>;
  updateLogotype(
    id: string,
    companyId: string | undefined,
    name: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<CompanyModel>;
  getCompanyLogotype(id: string): Promise<string>;
  mergeInto(companyId: string, intoCompanyId: string): Promise<void>;
  getAccessToEdit(companyId: string): Promise<boolean>;
}

export class CompaniesClient extends BaseClient implements ICompaniesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    withMembership: boolean | undefined,
    countryId: string | null | undefined
  ): Promise<CompanyModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyRoleId !== undefined && companyRoleId !== null)
      url_ += 'CompanyRoleId=' + encodeURIComponent('' + companyRoleId) + '&';
    if (withMembership === null) throw new Error("The parameter 'withMembership' cannot be null.");
    else if (withMembership !== undefined) url_ += 'WithMembership=' + encodeURIComponent('' + withMembership) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CompanyModel[]>(_response);
      });
  }

  getAccessToEdit(companyId: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/Companies/' + companyId + '/AccessToEdit';

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccessToEdit(_response);
      });
  }

  protected processGetAccessToEdit(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return _responseText === 'true' ? true : false;
      });
    }
    return Promise.resolve<boolean>(false);
  }

  registerNew(createCompanyModel: CreateCompanyModel): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Companies/RegisterNewCompany';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createCompanyModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<string>(_response);
      });
  }

  getLinkableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies/Linkable?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<LinkedCompanyModel[]>(_response);
      });
  }

  getLicensees(companyId: string | undefined): Promise<LicenseeModel[]> {
    let url_ = this.baseUrl + '/api/v1/Licensee/company/{id}?';
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace('{id}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLicensees(_response);
      });
  }

  protected processGetLicensees(response: Response): Promise<LicenseeModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <LicenseeModel[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<LicenseeModel[]>(<any>null);
  }

  getDevelopers(
    smartFilter: string | null | undefined,
    companyId: string | null | undefined,
    countryId: string | null | undefined,
    epdVersionId: string | null | undefined
  ): Promise<DeveloperCompanyModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies/Developers?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    if (epdVersionId !== undefined && epdVersionId !== null)
      url_ += 'EPDVersionId=' + encodeURIComponent('' + epdVersionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DeveloperCompanyModel[]>(_response);
      });
  }

  getVerifiers({
    smartFilter,
    companyId,
    countryId,
    isGlobalMarketplace,
    epdVersionId,
    verificationType,
  }: GetVerifiersParams): Promise<VerifierModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies/Verifiers?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    if (isGlobalMarketplace) url_ += 'IsGlobalMarketplace=true&';
    if (epdVersionId !== undefined && epdVersionId !== null)
      url_ += 'EPDVersionId=' + encodeURIComponent('' + epdVersionId) + '&';
    if (verificationType !== undefined && verificationType !== null)
      url_ += 'VerificationType=' + encodeURIComponent('' + verificationType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<VerifierModel[]>(_response);
      });
  }

  getIndividualVerifiers({
    smartFilter,
    companyId,
    countryId,
    isGlobalMarketplace,
    epdVersionId,
    verificationType,
  }: GetVerifiersParams): Promise<EPDIndividualVerifierModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies/IndividualVerifiers?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    if (isGlobalMarketplace) url_ += 'IsGlobalMarketplace=true&';
    if (epdVersionId !== undefined && epdVersionId !== null)
      url_ += 'EPDVersionId=' + encodeURIComponent('' + epdVersionId) + '&';
    if (verificationType !== undefined && verificationType !== null)
      url_ += 'VerificationType=' + encodeURIComponent('' + verificationType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<VerifierModel[]>(_response);
      });
  }

  getCertificationBodies({
    smartFilter,
    companyId,
    countryId,
    isGlobalMarketplace,
    epdVersionId,
    verificationType,
  }: GetVerifiersParams): Promise<EPDCertificationBodyModel[]> {
    let url_ = this.baseUrl + '/api/v1/Companies/CertificationBodies?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    if (isGlobalMarketplace) url_ += 'IsGlobalMarketplace=true&';
    if (epdVersionId !== undefined && epdVersionId !== null)
      url_ += 'EPDVersionId=' + encodeURIComponent('' + epdVersionId) + '&';
    if (verificationType !== undefined && verificationType !== null)
      url_ += 'VerificationType=' + encodeURIComponent('' + verificationType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<VerifierModel[]>(_response);
      });
  }

  get(id: string): Promise<CompanyModel> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CompanyModel>(_response);
      });
  }

  updateSettings(id: string, model: UpdateCompanySettingsModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}/Settings';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  updateInvoiceInfo(id: string, model: UpdateCompanyInvoiceInfoModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}/InvoiceInfo';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  updateCompanyProperty(updateCompanyPropertyModel: UpdateCompanyPropertyModel): Promise<CompanyModel> {
    let url_ = this.baseUrl + '/api/v1/Companies/UpdateCompanyProperty';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCompanyPropertyModel);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<CompanyModel>(_response);
      });
  }

  updateLogotype(
    id: string,
    companyId: string | undefined,
    name: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<CompanyModel> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}/Logotype';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (companyId === null || companyId === undefined) throw new Error("The parameter 'companyId' cannot be null.");
    else content_.append('CompanyId', companyId.toString());
    if (name !== null && name !== undefined) content_.append('Name', name.toString());
    if (bytes !== null && bytes !== undefined)
      content_.append('Bytes', bytes.data, bytes.fileName ? bytes.fileName : 'Bytes');

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<CompanyModel>(_response);
      });
  }

  getCompanyLogotype(id: string): Promise<any> {
    let url_ = this.baseUrl + '/api/v1/Companies/{id}/Logotype';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCompanyLogotype(_response);
      });
  }

  sendCompanyInvoiceCurrencyDisplayed(
    companyId: string | undefined,
    companyInvoiceCurrencyDialogDisplayed: boolean
  ): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/Companies/{companyId}/InvoiceCurrencyDialog';

    if (!companyId) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace('{companyId}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getPutOptions(companyInvoiceCurrencyDialogDisplayed.toString());

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }

  protected processGetCompanyLogotype(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.arrayBuffer().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText.byteLength == 0 ? null : _responseText;
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  mergeInto(companyId: string, intoCompanyId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Companies/{companyId}/MergeInto/{intoCompanyId}';
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace('{companyId}', encodeURIComponent('' + companyId));
    if (intoCompanyId === undefined || intoCompanyId === null)
      throw new Error("The parameter 'intoCompanyId' must be defined.");
    url_ = url_.replace('{intoCompanyId}', encodeURIComponent('' + intoCompanyId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  removeUserRoles(companyId: string, removeUserRolesModel: RemoveUserRolesModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Companies/{companyId}/RemoveUserRoles';
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace('{companyId}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(removeUserRolesModel);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }
}

export interface ILanguagesClient {
  getAll(): Promise<LanguageModel[]>;
}

export class LanguagesClient extends BaseClient implements ILanguagesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(): Promise<LanguageModel[]> {
    let url = this.baseUrl + '/api/v1/Languages';

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<LanguageModel[]>(_response);
      });
  }
}

export interface ICountriesClient {
  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    getLicenseeLicenseeCountries: boolean | null | undefined,
    companyId: string | null | undefined
  ): Promise<CountryModel[]>;
  get(id: string): Promise<CountryModel>;
  getRegions(): Promise<RegionModel[]>;
}

export class CountriesClient extends BaseClient implements ICountriesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    getLicenseeCountries: boolean | null | undefined,
    companyId: string | null | undefined
  ): Promise<CountryModel[]> {
    let url_ = this.baseUrl + '/api/v1/Countries?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyRoleId !== undefined && companyRoleId !== null)
      url_ += 'CompanyRoleId=' + encodeURIComponent('' + companyRoleId) + '&';
    if (getLicenseeCountries !== undefined && getLicenseeCountries !== null)
      url_ += 'GetLicenseeCountries=' + encodeURIComponent('' + getLicenseeCountries) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CountryModel[]>(_response);
      });
  }

  get(id: string): Promise<CountryModel> {
    let url_ = this.baseUrl + '/api/v1/Countries/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CountryModel>(_response);
      });
  }

  async getRegions(): Promise<RegionModel[]> {
    return (await axiosInstance.get<RegionModel[]>(`/api/v1/Countries/Regions`)).data;
  }
}

export interface ICPCClient {
  get(
    smartFilter: string | null | undefined,
    cPCLevel: CPCLevel | undefined,
    codes: string[] | null | undefined
  ): Promise<CPCModel[]>;
  getTree(): Promise<CPCTreeModel>;
}

export class CPCClient extends BaseClient implements ICPCClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(
    smartFilter: string | null | undefined,
    cPCLevel: CPCLevel | undefined,
    codes: string[] | null | undefined
  ): Promise<CPCModel[]> {
    let url_ = this.baseUrl + '/api/v1/CPC?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (cPCLevel === null) throw new Error("The parameter 'cPCLevel' cannot be null.");
    else if (cPCLevel !== undefined) url_ += 'CPCLevel=' + encodeURIComponent('' + cPCLevel) + '&';
    if (codes !== undefined && codes !== null)
      codes &&
        codes.forEach((item) => {
          url_ += 'Codes=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CPCModel[]>(_response);
      });
  }

  getTree(): Promise<CPCTreeModel> {
    let url_ = this.baseUrl + '/api/v1/CPC/Tree';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CPCTreeModel>(_response);
      });
  }
}

export interface IDataSourcesClient {
  get(): Promise<DataSourceModel[]>;
}

export class DataSourcesClient extends BaseClient implements IDataSourcesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(): Promise<DataSourceModel[]> {
    let url_ = this.baseUrl + '/api/v1/DataSources';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DataSourceModel[]>(_response);
      });
  }
}

export interface IDataSourceVersionsClient {
  getDataSourceVersions(dataSourceId: string): Promise<DataSourceVersionModel[]>;
}

export class DataSourceVersionsClient extends BaseClient implements IDataSourceVersionsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getDataSourceVersions(): Promise<DataSourceVersionModel[]> {
    let url_ = this.baseUrl + '/api/v1/DataSourceVersions';
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DataSourceVersionModel[]>(_response);
      });
  }
}

export interface IEPDClient {
  getAll(
    smartFilter: string | null | undefined,
    accountId: string | null | undefined,
    companyId: string | null | undefined,
    excludeCollectionId: string | null | undefined
  ): Promise<EPDModel[]>;
  create(createEPDModel: CreateEPDModel): Promise<EPDModel>;
  get(id: string): Promise<EPDModel>;
  update(id: string, updateEPDModel: UpdateEPDModel): Promise<void>;
  delete(id: string): Promise<void>;
  cancelUpdate(id: string): Promise<void>;
  updateEPDProperty(updateEPDPropertyModel: UpdateEPDPropertyModel): Promise<EPDModel>;
  updateEPDFileProperty(
    ePDId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<EPDModel>;
  addEPDFile(
    ePDId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined,
    documentTypeId: string | null,
    documentLanguageId: string | null
  ): Promise<EPDModel>;
  addLCAFile(epdId: string, file: File): Promise<EPDModel>;
  removeEPDFile(epdFileId: string, epdVersionId: string, propertyName: string): Promise<EPDModel>;
  arrangeEpdFiles(epdFileIds: string[]): Promise<void>;
  startVerification(id: string): Promise<EPDStateModel>;
  cancelVerification(id: string): Promise<EPDStateModel>;
  declineVerification(id: string, reason: string | undefined): Promise<EPDStateModel>;
  approve(id: string, currentDateTimeWithTimezone: string): Promise<EPDStateModel>;
  cancelDeclineVerification(id: string): Promise<EPDStateModel>;
  cancelApproveVerification(id: string): Promise<EPDStateModel>;
  publish(epdVersionId: string | undefined, id: string): Promise<boolean>;
  declinePublication(id: string, declineReason: string): Promise<EPDStateModel>;
  sendEpdForPublication(id: string): Promise<boolean>;
  cancelPublication(id: string): Promise<EPDStateModel>;
  sendEpdForPublicationEditorial(id: string, registrationEditorialModel: SendForPublicationEditorialModel): Promise<boolean>;
  deregister(id: string): Promise<EPDStateModel>;
  cancelDeregistration(id: string): Promise<EPDStateModel>;
  depublish(id: string): Promise<EPDStateModel>;
  unlock(id: string): Promise<boolean>;
  editorialUpdating(id: string): Promise<boolean>;
  connectDeveloper(id: string, membershipId: string): Promise<EPDModel>;
  connectVerifier(model: ConnectVerifierModel): Promise<EPDModel>;
  createCopy(copyEpdModel: CopyEpdModel): Promise<EPDModel>;
  createMultiCopy(copyEpdModel: MultiCopyEpdModel): Promise<void>;
  getILCDRelation(id: string): Promise<EPDILCDRelation>;
  getEPDVerificationStatesModel(id: string | null | undefined): Promise<EPDVerificationStatesModel>;
  getAllEPDCopyGroupFiles(id: string): Promise<EPDCopyGroupFilesModel>;
  removeCopyGroupFile(copyGroupId: string, fileId: string): Promise<EPDCopyGroupFilesModel>;
  addCopyGroupFile(
    copyGroupId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<EPDCopyGroupFilesModel>;
  getDictionaryValues(dictionaryCode?: string): Promise<DictionaryValue[]>;
}

export class EPDClient extends BaseClient implements IEPDClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getDictionaryValues(dictionaryCode?: string): Promise<DictionaryValue[]> {
    let url_ = this.baseUrl + `/api/v1/Compiler/Dictionaries/Values?dictionaryCode=${dictionaryCode}`;

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DictionaryValue[]>(_response);
      });
  }

  getOkobaudatProductCategories(): Promise<OkobaudatProductCategoryModel[]> {
    let url_ = this.baseUrl + `/api/v1/OkobaudatProductCategories`;

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<OkobaudatProductCategoryModel[]>(_response);
      });
  }

  getAll(
    smartFilter: string | null | undefined,
    accountId: string | null | undefined,
    companyId: string | null | undefined,
    excludeCollectionId: string | null | undefined
  ): Promise<EPDModel[]> {
    let url_ = this.baseUrl + '/api/v1/EPD?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (accountId !== undefined && accountId !== null) url_ += 'AccountId=' + encodeURIComponent('' + accountId) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (excludeCollectionId !== undefined && excludeCollectionId !== null)
      url_ += 'ExcludeCollectionId=' + encodeURIComponent('' + excludeCollectionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<EPDModel[]>(_response);
      });
  }

  getAllGroups(
    smartFilter: string | null | undefined,
    accountId: string | null | undefined,
    companyId: string | null | undefined
  ): Promise<EpdGroupDashboardModel[]> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (accountId !== undefined && accountId !== null) url_ += 'AccountId=' + encodeURIComponent('' + accountId) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<EpdGroupDashboardModel[]>(_response);
      });
  }

  getEPDVerificationStatesModel(id: string | null | undefined): Promise<EPDVerificationStatesModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/EPD/{id}/VerificationActionStates';
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<EPDVerificationStatesModel>(_response);
      });
  }

  getEpdToCopyDataSources(findModel: FindEPDsToCopyModel): Promise<EPDCopyGroupDataSourcesModel> {
    let url_ = this.baseUrl + '/api/v2/CopyEPD?';
    if (findModel.accountId !== undefined && findModel.accountId !== null)
      url_ += 'AccountId=' + encodeURIComponent('' + findModel.accountId) + '&';
    if (findModel.companyId !== undefined && findModel.companyId !== null)
      url_ += 'CompanyId=' + encodeURIComponent('' + findModel.companyId) + '&';
    if (findModel.copyGroupId !== undefined && findModel.copyGroupId !== null)
      url_ += 'CopyGroupId=' + encodeURIComponent('' + findModel.copyGroupId) + '&';

    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<EPDCopyGroupDataSourcesModel>(_response);
      });
  }

  create(createEPDModel: CreateEPDModel): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createEPDModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<EPDModel>(_response);
      });
  }

  createCompilerEpd(createEPDModel: CreateEPDModel): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/Compiler';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createEPDModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<EPDModel>(_response);
      });
  }

  createCopy(copyEpdModel: CopyEpdModel): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/CopyEPD';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(copyEpdModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<EPDModel>(_response);
      });
  }

  createMultiCopy(copyEpdModel: MultiCopyEpdModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/CopyMultiEPD';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(copyEpdModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<void>(_response);
      });
  }

  createEpdCopies(copyEpdModel: CopyEpdV2Model): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/CopyEPD/CopyEPDs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(copyEpdModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<string>(_response);
      });
  }

  createEpdSingleCopy(copyEpdModel: CopyEpdV2Model): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/CopyEPD/CopySingleEPD';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(copyEpdModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<string>(_response);
      });
  }

  get(id: string): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDModel>(_response);
      });
  }

  getEpdGroup(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/CopyEPD/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EpdCopyGroupWizardModel>(_response);
      });
  }

  getEpdDataToCopyAllDataset(id: string): Promise<EPDDataToCopyAllModel> {
    let url_ = this.baseUrl + '/api/v2/CopyEPD/{id}/EPDDataToCopyAll';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDDataToCopyAllModel>(_response);
      });
  }

  deleteEpdCopyGroup(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  addNewEpdToEpdCopyGroup(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/add';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(id);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  unlinkEpdFromCopyGroup(groupId: string, epdVersionId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{groupId}/unlink/{epdId}';
    if (groupId === undefined || groupId === null) throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace('{groupId}', encodeURIComponent('' + groupId));
    if (epdVersionId === undefined || epdVersionId === null) throw new Error("The parameter 'epdId' must be defined.");
    url_ = url_.replace('{epdId}', encodeURIComponent('' + epdVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  editApprovedWithVerification(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/editApprovedWithVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  editApprovedEditorial(epdVersionId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/editApprovedEditorial';
    if (epdVersionId === undefined || epdVersionId === null)
      throw new Error("The parameter 'epdVersionId' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + epdVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  deleteEpdFromCopyGroup(groupId: string, epdVersionId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{groupId}/delete/{epdId}';
    if (groupId === undefined || groupId === null) throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace('{groupId}', encodeURIComponent('' + groupId));
    if (epdVersionId === undefined || epdVersionId === null) throw new Error("The parameter 'epdId' must be defined.");
    url_ = url_.replace('{epdId}', encodeURIComponent('' + epdVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  addCopyGroupFile(
    copyGroupId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<EPDCopyGroupFilesModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/AddFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (copyGroupId === null || copyGroupId === undefined) throw new Error("The parameter 'copyGroupId' cannot be null.");
    else content_.append('EPDCopyGroupId', copyGroupId.toString());
    if (propertyName !== null && propertyName !== undefined) content_.append('PropertyName', propertyName.toString());
    if (newValue !== null && newValue !== undefined)
      content_.append('NewValue', newValue.data, newValue.fileName ? newValue.fileName : 'NewValue');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDCopyGroupFilesModel>(_response);
      });
  }

  removeCopyGroupFile(copyGroupId: string, fileId: string): Promise<EPDCopyGroupFilesModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{copyGroupId}/deleteFile/{fileId}';
    if (copyGroupId === undefined || copyGroupId === null) throw new Error("The parameter 'copyGroupId' must be defined.");
    url_ = url_.replace('{copyGroupId}', encodeURIComponent('' + copyGroupId));
    if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDCopyGroupFilesModel>(_response);
      });
  }

  getAllEPDCopyGroupFiles(id: string): Promise<EPDCopyGroupFilesModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/GetAllEPDCopyGroupFiles';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDCopyGroupFilesModel>(_response);
      });
  }

  update(id: string, updateEPDModel: UpdateEPDModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateEPDModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  cancelUpdate(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/CancelUpdate/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  updateEPDProperty(updateEPDPropertyModel: UpdateEPDPropertyModel): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/UpdateEPDProperty';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateEPDPropertyModel);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDModel>(_response);
      });
  }

  confirmUpdate(epdId: string, epdVersionId: string): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/ConfirmUpdateEpd';
    if (epdId === undefined || epdId === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + epdId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(epdVersionId);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDModel>(_response);
      });
  }

  updateCopyEPDGroup(updateEPDCopyGroup: UpdateEPDGroupPropertyModel): Promise<EPDCopyGroupModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/UpdateCopyGroupProperty';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateEPDCopyGroup);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDCopyGroupModel>(_response);
      });
  }

  updateEPDFileProperty(
    ePDId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/UpdateEPDFileProperty';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (ePDId === null || ePDId === undefined) throw new Error("The parameter 'ePDId' cannot be null.");
    else content_.append('EPDId', ePDId.toString());
    if (propertyName !== null && propertyName !== undefined) content_.append('PropertyName', propertyName.toString());
    if (newValue !== null && newValue !== undefined)
      content_.append('NewValue', newValue.data, newValue.fileName ? newValue.fileName : 'NewValue');

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDModel>(_response);
      });
  }

  addEPDFile(
    ePDId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined,
    documentTypeId: string | null,
    documentLanguageId: string | null
  ): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/AddEPDFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (ePDId === null || ePDId === undefined) throw new Error("The parameter 'ePDId' cannot be null.");
    else content_.append('EPDId', ePDId.toString());
    if (propertyName !== null && propertyName !== undefined) content_.append('PropertyName', propertyName.toString());
    if (newValue !== null && newValue !== undefined)
      content_.append('NewValue', newValue.data, newValue.fileName ? newValue.fileName : 'NewValue');

    if (!!documentTypeId) {
      content_.append('DocumentTypeId', documentTypeId);
    }

    if (!!documentLanguageId) {
      content_.append('DocumentLanguageId', documentLanguageId);
    }

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EPDModel>(_response);
      });
  }

  async addLCAFile(epdId: string, file: File): Promise<EPDModel> {
    const formData = new FormData();
    formData.append('EPDId', epdId);
    formData.append('PropertyName', 'LCA');
    formData.append('NewValue', file);
    const response = await axiosInstance.post<EPDModel>('/api/v1/EPD/AddEPDFile', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  removeEPDFile(epdFileId: string, epdVersionId: string): Promise<EPDModel> {
    let url_ =
      this.baseUrl + `/api/v1/EPD/${encodeURIComponent(epdVersionId)}/RemoveEPDFile/${encodeURIComponent(epdFileId)}`;

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveEPDFile(_response);
      });
  }

  validateLCAFile(file: FileParameter | null | undefined): Promise<LcaXLValidationError[]> {
    let url_ = this.baseUrl + '/api/v1/LCAFile/validate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined) content_.append('File', file.data, file.fileName ? file.fileName : 'File');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<LcaXLValidationError[]>(_response);
      });
  }

  protected processRemoveEPDFile(response: Response): Promise<EPDModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDModel>(<any>null);
  }

  arrangeEpdFiles(epdFileIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/EPD/ArrangeEPDFiles';
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(epdFileIds);
    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<void>(_response);
      });
  }

  startVerification(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/StartVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processStartVerification(_response);
      });
  }

  protected processStartVerification(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  startGroupVerification(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/StartVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  cancelGroupVerification(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/CancelVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  confirmGroupVerification(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/ConfirmVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  retractGroupVerification(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/RetractVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  sendGroupToPublish(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/SendToPublish';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  async cancelGroupPublication(id: string): Promise<void> {
    const options = await this.transformOptions(this.getPutOptions(''));
    const response = await this.http.fetch(this.baseUrl + `/api/v2/EPDCopyGroup/${id}/CancelPublication`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }

  sendGroupToPublishByLicenseeAdmin(id: string, licenseeAdminReviewComment: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/SendToPublishByLicenseeAdmin';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    content_.append('LicenseeAdminReviewComment', licenseeAdminReviewComment);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  declineGroup(id: string, declineReason?: string | undefined): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/Decline';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (declineReason) {
      content_.append('DeclineReason', declineReason);
    }

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }

  publishGroup(id: string): Promise<EpdCopyGroupWizardModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/Publish';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<EpdCopyGroupWizardModel>(_response);
      });
  }

  getEPDGroupState(id: string): Promise<EPDCopyGroupStateModel> {
    let url_ = this.baseUrl + '/api/v2/EPDCopyGroup/{id}/GetGroupState';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDCopyGroupStateModel>(_response);
      });
  }

  cancelVerification(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/CancelVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelVerification(_response);
      });
  }

  protected processCancelVerification(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  approve(id: string, currentDateTimeWithTimezone: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/Approve';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    content_.append('LastRevisionDate', currentDateTimeWithTimezone);

    let options_ = <RequestInit>{
      method: 'PUT',
      body: content_,
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processApprove(_response);
      });
  }

  protected processApprove(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  declineVerification(id: string, reason: string | undefined): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/DeclineVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (reason) {
      content_.append('DeclineReason', reason.toString());
    }

    let options_ = <RequestInit>{
      method: 'PUT',
      body: content_,
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeclineVerification(_response);
      });
  }

  protected processDeclineVerification(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  cancelApproveVerification(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/CancelApproveVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelApproveVerification(_response);
      });
  }

  protected processCancelApproveVerification(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  cancelDeclineVerification(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/CancelDeclineVerification';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelDeclineVerification(_response);
      });
  }

  protected processCancelDeclineVerification(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  async publish(epdVersionId: string | undefined, id: string): Promise<boolean> {
    if (!id) {
      throw new Error("The parameter 'id' must be defined.");
    }
    if (!epdVersionId) {
      throw new Error("The parameter 'epdVersionId' must be defined.");
    }

    const url = `${this.baseUrl}/api/v1/EPD/${id}/Publish?epdVersionId=${epdVersionId}`;
    const response = await this.http.fetch(url, await this.transformOptions(this.getPutOptions('')));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }

    return response.json();
  }

  async declinePublication(id: string, declineReason: string): Promise<EPDStateModel> {
    if (!id) {
      throw new Error("The parameter 'id' is must be defined.");
    }

    const options = await this.transformOptions(this.getPutOptions(JSON.stringify({ declineReason })));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/DeclinePublication`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async sendEpdForPublication(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/SendForPublication';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    const response = await this.http.fetch(url_, await this.transformOptions(options_));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async cancelPublication(id: string): Promise<EPDStateModel> {
    if (!id) {
      throw new Error("The parameter 'id' is must be defined.");
    }

    const options = await this.transformOptions(this.getPutOptions(''));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/CancelPublication`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async licenseeAdminSendToPublish(id: string, licenseeAdminReviewComment: string): Promise<EPDStateModel> {
    if (!id) {
      throw new Error("The parameter 'id' is must be defined.");
    }

    const options = await this.transformOptions(this.getPutOptions(JSON.stringify({ licenseeAdminReviewComment })));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/LicenseeAdminSendToPublish`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async sendEpdForPublicationEditorial(
    id: string,
    registrationEditorialModel: SendForPublicationEditorialModel
  ): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/SendForPublicationEditorial';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(registrationEditorialModel);

    let options_ = this.getPutOptions(content_);

    const response = await this.http.fetch(url_, await this.transformOptions(options_));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  protected processSendEpdForPublicationEditorial(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  deregister(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/Deregister';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeregister(_response);
      });
  }

  protected processDeregister(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  cancelDeregistration(id: string): Promise<EPDStateModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/CancelDeregistration';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelDeregistration(_response);
      });
  }

  protected processCancelDeregistration(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  async depublish(
    id: string,
    depublicationReason?: string,
    depublishType?: DepublishReasonType | null
  ): Promise<EPDStateModel> {
    if (!id) {
      throw new Error("The parameter 'id' is must be defined.");
    }

    const options = await this.transformOptions(this.getPutOptions(JSON.stringify({ depublicationReason, depublishType })));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/Depublish`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async unlock(id: string): Promise<boolean> {
    const options = await this.transformOptions(this.getPutOptions(''));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/Unlock`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  async editorialUpdating(id: string): Promise<boolean> {
    const options = await this.transformOptions(this.getPutOptions(''));
    const response = await this.http.fetch(this.baseUrl + `/api/v1/EPD/${id}/EditorialUpdating`, options);
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  protected processUnlock(response: Response): Promise<EPDStateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <EPDStateModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDStateModel>(<any>null);
  }

  connectDeveloper(id: string, membershipId: string): Promise<EPDModel> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/ConnectDeveloper/{membershipId}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (membershipId === undefined || membershipId === null)
      throw new Error("The parameter 'membershipId' must be defined.");
    url_ = url_.replace('{membershipId}', encodeURIComponent('' + membershipId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDModel>(_response);
      });
  }

  connectVerifier(model: ConnectVerifierModel): Promise<EPDModel> {
    const url = this.baseUrl + `/api/v1/EPD/${model.epdId}/ConnectVerifier`;

    const options = this.getPutOptions(JSON.stringify(model));
    return this.transformOptions(options)
      .then((transformedOptions_) => {
        return this.http.fetch(url, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDModel>(_response);
      });
  }

  getILCDRelation(id: string): Promise<EPDILCDRelation> {
    let url_ = this.baseUrl + '/api/v1/EPD/{id}/ILCDRelation';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDILCDRelation>(_response);
      });
  }

  getILCDRelationEPDMappingList(id: string): Promise<EPDRelationsListModel[]> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/epd/{id}/relationlist';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<EPDRelationsListModel[]>(_response);
      });
  }
}

export interface IFilesClient {
  createFile(
    name: string | null | undefined,
    fileTypeCode: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<FileModel>;
  updateFile(
    id: string,
    fileId: string | undefined,
    name: string | null | undefined,
    fileTypeCode: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<FileModel>;
  getFile(id: string): Promise<FileModel>;
  delete(id: string): Promise<void>;
  getFileData(fileId: string): Promise<string>;
}

export class FilesClient extends BaseClient implements IFilesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  createFile(
    name: string | null | undefined,
    fileTypeCode: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<FileModel> {
    let url_ = this.baseUrl + '/api/v1/Files';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (name !== null && name !== undefined) content_.append('Name', name.toString());
    if (fileTypeCode !== null && fileTypeCode !== undefined) content_.append('FileTypeCode', fileTypeCode.toString());
    if (bytes !== null && bytes !== undefined)
      content_.append('Bytes', bytes.data, bytes.fileName ? bytes.fileName : 'Bytes');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<FileModel>(_response);
      });
  }

  updateFile(
    id: string,
    fileId: string | undefined,
    name: string | null | undefined,
    fileTypeCode: string | null | undefined,
    bytes: FileParameter | null | undefined
  ): Promise<FileModel> {
    let url_ = this.baseUrl + '/api/v1/Files/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (fileId === null || fileId === undefined) throw new Error("The parameter 'fileId' cannot be null.");
    else content_.append('FileId', fileId.toString());
    if (name !== null && name !== undefined) content_.append('Name', name.toString());
    if (fileTypeCode !== null && fileTypeCode !== undefined) content_.append('FileTypeCode', fileTypeCode.toString());
    if (bytes !== null && bytes !== undefined)
      content_.append('Bytes', bytes.data, bytes.fileName ? bytes.fileName : 'Bytes');

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<FileModel>(_response);
      });
  }

  getFile(id: string): Promise<FileModel> {
    let url_ = this.baseUrl + '/api/v1/Files/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<FileModel>(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Files/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  getFileData(fileId: string): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Files/{fileId}/Data';
    if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }
}

export interface IGeographicalScopesClient {
  getAll(smartFilter: string | null | undefined): Promise<GeographicalScopeModel[]>;
  get(id: string): Promise<GeographicalScopeModel>;
}

export class GeographicalScopesClient extends BaseClient implements IGeographicalScopesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(smartFilter: string | null | undefined): Promise<GeographicalScopeModel[]> {
    let url_ = this.baseUrl + '/api/v1/GeographicalScopes?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<GeographicalScopeModel[]>(_response);
      });
  }

  get(id: string): Promise<GeographicalScopeModel> {
    let url_ = this.baseUrl + '/api/v1/GeographicalScopes/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<GeographicalScopeModel>(_response);
      });
  }
}

export interface IInvitationsClient {
  getAll(companyId: string | null | undefined): Promise<InvitationModel[]>;
  get(id: string): Promise<InvitationModel>;
  put(id: string, invitation: InvitationModel): Promise<void>;
  delete(id: string): Promise<void>;
  createInvitation(createInvitationModel: CreateInvitationModel): Promise<InvitationModel>;
  accept(id: string): Promise<Membership>;
  reject(id: string): Promise<void>;
  inquireCollaboration(inquireCollaborationModel: InquireCollaborationModel): Promise<void>;
}

export class InvitationsClient extends BaseClient implements IInvitationsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(companyId: string | null | undefined): Promise<InvitationModel[]> {
    let url_ = this.baseUrl + '/api/v1/Invitations?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<InvitationModel[]>(_response);
      });
  }

  getAllByUser(): Promise<InvitationModel[]> {
    let url_ = this.baseUrl + '/api/v1/Invitations/GetAllByUser';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<InvitationModel[]>(_response);
      });
  }

  getInvitesCountByUser(): Promise<number> {
    const url_ = this.baseUrl + '/api/v1/Invitations/Count';
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<number>(_response);
      });
  }

  get(id: string): Promise<InvitationModel> {
    let url_ = this.baseUrl + '/api/v1/Invitations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<InvitationModel>(_response);
      });
  }

  put(id: string, invitation: InvitationModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invitations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(invitation);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invitations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  createInvitation(createInvitationModel: CreateInvitationModel): Promise<InvitationModel> {
    let url_ = this.baseUrl + '/api/v1/Invitations/CreateInvitation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createInvitationModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<InvitationModel>(_response);
      });
  }

  accept(id: string): Promise<Membership> {
    let url_ = this.baseUrl + '/api/v1/Invitations/{id}/Accept';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<Membership>(_response);
      });
  }

  reject(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invitations/{id}/Reject';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  inquireCollaboration(inquireCollaborationModel: InquireCollaborationModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invitations/InquireCollaboration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(inquireCollaborationModel);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInquireCollaboration(_response);
      });
  }

  protected processInquireCollaboration(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export interface IInvoicesClient {
  get(id: string): Promise<InvoiceModel>;
  put(id: string, invoiceModel: InvoiceModel): Promise<InvoiceModel>;
  get2(accountId: string | undefined): Promise<InvoiceSummaryModel>;
  approve(id: string): Promise<void>;
  decline(id: string, declineInvoiceModel: DeclineInvoiceModel): Promise<void>;
  getInvoiceData(invoiceId: string): Promise<string>;
}

export class InvoicesClient extends BaseClient implements IInvoicesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(id: string): Promise<InvoiceModel> {
    let url_ = this.baseUrl + '/api/v1/Invoices/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<InvoiceModel>(_response);
      });
  }

  put(id: string, invoiceModel: InvoiceModel): Promise<InvoiceModel> {
    let url_ = this.baseUrl + '/api/v1/Invoices/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(invoiceModel);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<InvoiceModel>(_response);
      });
  }

  get2(accountId: string | undefined): Promise<InvoiceSummaryModel> {
    let url_ = this.baseUrl + '/api/v1/Invoices/summary?';
    if (accountId === null) throw new Error("The parameter 'accountId' cannot be null.");
    else if (accountId !== undefined) url_ += 'AccountId=' + encodeURIComponent('' + accountId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<InvoiceSummaryModel>(_response);
      });
  }

  approve(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invoices/{id}/Approve';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  decline(id: string, declineInvoiceModel: DeclineInvoiceModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Invoices/{id}/Decline';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(declineInvoiceModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  getInvoiceData(invoiceId: string): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Invoices/{invoiceId}/Data';
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }
}

export interface IMaterialPropertiesClient {
  get(): Promise<MaterialPropertyModel[]>;
}

export class MaterialPropertiesClient extends BaseClient implements IMaterialPropertiesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(): Promise<MaterialPropertyModel[]> {
    let url_ = this.baseUrl + '/api/v1/MaterialProperties';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<MaterialPropertyModel[]>(_response);
      });
  }
}

export interface IMembershipsClient {
  getAll(
    companyId: string | null | undefined,
    roleId: string | null | undefined,
    userId: string | null | undefined,
    accountId: string | null | undefined
  ): Promise<MembershipModel[]>;
  create(createMembershipModel: CreateMembershipModel): Promise<Membership>;
  getVerifierMemberships(companyId: string | null | undefined): Promise<EPDVerifierModel[]>;
  get(id: string): Promise<MembershipModel>;
  getUserAdminLicensees(companyId: string | null | undefined): Promise<UserAdminLicenseesModel[]>;
  put(id: string, membership: MembershipModel): Promise<void>;
  delete(id: string): Promise<void>;
  invite(membershipId: string | undefined): Promise<HttpStatusCode>;
  connect(membershipId: string | undefined, epdId: string | undefined): Promise<HttpStatusCode>;
}

export class MembershipsClient extends BaseClient implements IMembershipsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(
    companyId: string | null | undefined,
    roleId: string | null | undefined,
    userId: string | null | undefined,
    accountId: string | null | undefined
  ): Promise<MembershipModel[]> {
    let url_ = this.baseUrl + '/api/v1/Memberships?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (roleId !== undefined && roleId !== null) url_ += 'RoleId=' + encodeURIComponent('' + roleId) + '&';
    if (userId !== undefined && userId !== null) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (accountId !== undefined && accountId !== null) url_ += 'AccountId=' + encodeURIComponent('' + accountId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<MembershipModel[]>(_response);
      });
  }

  create(createMembershipModel: CreateMembershipModel): Promise<Membership> {
    let url_ = this.baseUrl + '/api/v1/Memberships';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createMembershipModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: Response): Promise<Membership> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 = _responseText === '' ? null : <Membership>JSON.parse(_responseText, this.jsonParseReviver);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Membership>(<any>null);
  }

  getUserAdminLicensees(userId: string | null | undefined): Promise<UserAdminLicenseesModel[]> {
    let url_ = this.baseUrl + '/api/v1/Memberships/UserAdminLicensees?';
    if (userId !== undefined && userId !== null) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<UserAdminLicenseesModel[]>(_response);
      });
  }

  getVerifierMemberships(companyId: string | null | undefined): Promise<EPDVerifierModel[]> {
    let url_ = this.baseUrl + '/api/v1/Memberships/Verifiers?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<EPDVerifierModel[]>(_response);
      });
  }

  get(id: string): Promise<MembershipModel> {
    let url_ = this.baseUrl + '/api/v1/Memberships/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<MembershipModel>(_response);
      });
  }

  put(id: string, membership: MembershipModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Memberships/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(membership);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Memberships/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  invite(membershipId: string | undefined): Promise<HttpStatusCode> {
    let url_ = this.baseUrl + '/api/v1/Memberships/Invite?';
    if (membershipId === null) throw new Error("The parameter 'membershipId' cannot be null.");
    else if (membershipId !== undefined) url_ += 'MembershipId=' + encodeURIComponent('' + membershipId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<HttpStatusCode>(_response);
      });
  }

  connect(membershipId: string | undefined, epdId: string | undefined): Promise<HttpStatusCode> {
    let url_ = this.baseUrl + '/api/v1/Memberships/Connect?';
    if (membershipId === null) throw new Error("The parameter 'membershipId' cannot be null.");
    else if (membershipId !== undefined) url_ += 'MembershipId=' + encodeURIComponent('' + membershipId) + '&';
    if (epdId === null) throw new Error("The parameter 'epdId' cannot be null.");
    else if (epdId !== undefined) url_ += 'EpdId=' + encodeURIComponent('' + epdId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<HttpStatusCode>(_response);
      });
  }
}

export interface INewsletterClient {
  signUp(signUpNewsletterModel: SignUpNewsletterModel): Promise<HttpStatusCode>;
}

export class NewsletterClient extends BaseClient implements INewsletterClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  signUp(signUpNewsletterModel: SignUpNewsletterModel): Promise<HttpStatusCode> {
    let url_ = this.baseUrl + '/api/v1/Newsletter';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(signUpNewsletterModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<HttpStatusCode>(_response);
      });
  }
}

export interface IPCRClient {
  getAll(query: FindPCRsModel): Promise<PCRModel[]>;
  create(createPCRModel: CreatePCRModel): Promise<PCRModel>;
  update(id: string, updatePCRModel: UpdatePCRModel): Promise<void>;
  delete(id: string): Promise<void>;
  updatePCRProperty(updatePCRPropertyModel: UpdatePCRPropertyModel): Promise<PCRModel>;
  addPCRFile(
    pCRId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<PCRModel>;
  removePCRFile(pCRId: string | undefined, fileId: string | undefined): Promise<PCRModel>;
}

export class PCRClient extends BaseClient implements IPCRClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll({
    smartFilter,
    excludedSubstringFilter,
    pcrStatusSelection,
    productCategoryId,
    isDisabled,
    targetEPDFormat,
    pcrType,
    mainPCRId,
  }: FindPCRsModel): Promise<PCRModel[]> {
    let url_ = this.baseUrl + '/api/v1/PCR?';

    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';

    if (!!excludedSubstringFilter)
      url_ += 'ExcludedSubstringFilter=' + encodeURIComponent('' + excludedSubstringFilter) + '&';

    if (pcrStatusSelection === null) throw new Error("The parameter 'pCRStatusSelection' cannot be null.");
    else if (pcrStatusSelection !== undefined)
      url_ += 'PCRStatusSelection=' + encodeURIComponent('' + pcrStatusSelection) + '&';

    if (productCategoryId !== undefined && productCategoryId !== null)
      url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';

    if (isDisabled !== undefined && isDisabled !== null) url_ += 'IsDisabled=' + encodeURIComponent('' + isDisabled) + '&';

    if (targetEPDFormat) url_ += `TargetEPDFormat=${targetEPDFormat}&`;

    if (pcrType) url_ += `PCRType=${pcrType}&`;

    if (mainPCRId) url_ += `MainPCRId=${mainPCRId}&`;

    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<PCRModel[]>(_response);
      });
  }

  create(createPCRModel: CreatePCRModel): Promise<PCRModel> {
    let url_ = this.baseUrl + '/api/v1/PCR';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPCRModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<PCRModel>(_response);
      });
  }

  update(id: string, updatePCRModel: UpdatePCRModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/PCR/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updatePCRModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/PCR/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  updatePCRProperty(updatePCRPropertyModel: UpdatePCRPropertyModel): Promise<PCRModel> {
    let url_ = this.baseUrl + '/api/v1/PCR/UpdatePCRProperty';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updatePCRPropertyModel);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<PCRModel>(_response);
      });
  }

  addPCRFile(
    pCRId: string | undefined,
    propertyName: string | null | undefined,
    newValue: FileParameter | null | undefined
  ): Promise<PCRModel> {
    let url_ = this.baseUrl + '/api/v1/PCR/AddPCRFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (pCRId === null || pCRId === undefined) throw new Error("The parameter 'pCRId' cannot be null.");
    else content_.append('PCRId', pCRId.toString());
    if (propertyName !== null && propertyName !== undefined) content_.append('PropertyName', propertyName.toString());
    if (newValue !== null && newValue !== undefined)
      content_.append('NewValue', newValue.data, newValue.fileName ? newValue.fileName : 'NewValue');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<PCRModel>(_response);
      });
  }

  removePCRFile(pCRId: string | undefined, fileId: string | undefined): Promise<PCRModel> {
    let url_ = this.baseUrl + '/api/v1/PCR/RemovePCRFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (pCRId === null || pCRId === undefined) throw new Error("The parameter 'pCRId' cannot be null.");
    else content_.append('PCRId', pCRId.toString());
    if (fileId === null || fileId === undefined) throw new Error("The parameter 'fileId' cannot be null.");
    else content_.append('FileId', fileId.toString());

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemovePCRFile(_response);
      });
  }

  protected processRemovePCRFile(response: Response): Promise<PCRModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <PCRModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PCRModel>(<any>null);
  }
}

export interface IProductCategoriesClient {
  getAll(smartFilter: string | null | undefined, includeTree: boolean | undefined): Promise<ProductCategoryModel[]>;
  get(id: string): Promise<ProductCategoryModel>;
}

export class ProductCategoriesClient extends BaseClient implements IProductCategoriesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(smartFilter: string | null | undefined, includeTree: boolean | undefined): Promise<ProductCategoryModel[]> {
    let url_ = this.baseUrl + '/api/v1/ProductCategories?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (includeTree === null) throw new Error("The parameter 'includeTree' cannot be null.");
    else if (includeTree !== undefined) url_ += 'IncludeTree=' + encodeURIComponent('' + includeTree) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<ProductCategoryModel[]>(_response);
      });
  }

  getRoot(): Promise<ProductCategoryModel[]> {
    let url_ = this.baseUrl + '/api/v1/ProductCategories/RootCategories';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<ProductCategoryModel[]>(_response);
      });
  }

  getNonRoot(): Promise<ProductCategoryModel[]> {
    let url_ = this.baseUrl + '/api/v1/ProductCategories/NonRootCategories';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<ProductCategoryModel[]>(_response);
      });
  }

  get(id: string): Promise<ProductCategoryModel> {
    let url_ = this.baseUrl + '/api/v1/ProductCategories/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<ProductCategoryModel>(_response);
      });
  }
}

export interface IProgramOperatorsClient {
  getAll(smartFilter: string | null | undefined): Promise<ProgramOperatorModel[]>;
  get(id: string): Promise<ProgramOperatorModel>;
}

export class ProgramOperatorsClient extends BaseClient implements IProgramOperatorsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(smartFilter: string | null | undefined): Promise<ProgramOperatorModel[]> {
    let url_ = this.baseUrl + '/api/v1/ProgramOperators?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<ProgramOperatorModel[]>(_response);
      });
  }

  get(id: string): Promise<ProgramOperatorModel> {
    let url_ = this.baseUrl + '/api/v1/ProgramOperators/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<ProgramOperatorModel>(_response);
      });
  }
}

export interface IRequestsClient {
  getAll(companyId: string | null | undefined): Promise<RequestModel[]>;
  get(id: string): Promise<RequestModel>;
  put(id: string, request: RequestModel): Promise<void>;
  delete(id: string): Promise<void>;
  createRequest(createRequestModel: CreateRequestModel): Promise<RequestModel>;
  accept(id: string): Promise<Membership>;
  reject(id: string): Promise<void>;
}

export class RequestsClient extends BaseClient implements IRequestsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(companyId: string | null | undefined): Promise<RequestModel[]> {
    let url_ = this.baseUrl + '/api/v1/Requests?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<RequestModel[]>(_response);
      });
  }

  getUserRequests(): Promise<RequestModel[]> {
    let url_ = this.baseUrl + '/api/v1/Requests/UserRequests';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<RequestModel[]>(_response);
      });
  }

  get(id: string): Promise<RequestModel> {
    let url_ = this.baseUrl + '/api/v1/Requests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<RequestModel>(_response);
      });
  }

  put(id: string, request: RequestModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Requests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Requests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  createRequest(createRequestModel: CreateRequestModel): Promise<RequestModel> {
    let url_ = this.baseUrl + '/api/v1/Requests/CreateRequest';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createRequestModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<RequestModel>(_response);
      });
  }

  accept(id: string): Promise<Membership> {
    let url_ = this.baseUrl + '/api/v1/Requests/{id}/Accept';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<Membership>(_response);
      });
  }

  reject(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Requests/{id}/Reject';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }
}

export interface IRolesClient {
  get(companyId: string | null | undefined): Promise<RoleModel[]>;
  getUserAffiliatedCompaniesPage(page: number, pageSize: number): Promise<PagedResult<UserAffiliatedCompanyModel>>;
}

export class RolesClient extends BaseClient implements IRolesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(companyId: string | null | undefined): Promise<RoleModel[]> {
    let url_ = this.baseUrl + '/api/v1/Roles?';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<RoleModel[]>(_response);
      });
  }

  getUserAffiliatedCompaniesPage(page: number, pageSize: number): Promise<PagedResult<UserAffiliatedCompanyModel>> {
    let url_ = this.baseUrl + '/api/v1/Roles/UserAffiliatedCompanies/{page}/{pageSize}';
    if (page === undefined || page === null) throw new Error("The parameter 'page' must be defined.");
    url_ = url_.replace('{page}', encodeURIComponent('' + page));
    if (pageSize === undefined || pageSize === null) throw new Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace('{pageSize}', encodeURIComponent('' + pageSize));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<PagedResult<UserAffiliatedCompanyModel>>(_response);
      });
  }
}

export class SecurityClient extends BaseClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getMe = async (params: BaseQueryParams) => (await axiosInstance.get<UserModel>('/api/v1/Security/me', params)).data;

  changePassword(model: ChangePasswordModel): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/Security/ChangePassword';
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(model);
    let options_ = this.getPutOptions(content_);
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }

  login(model: LoginModel): Promise<UserModel> {
    let url_ = this.baseUrl + '/api/v1/Security/Login';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLogin(_response);
      });
  }

  protected processLogin(response: Response): Promise<UserModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 412) {
      return response.text().then((_responseText) => {
        let result412: any = null;
        result412 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result412);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserModel>(<any>null);
  }

  async loginAs(model: LoginAsModel): Promise<UserModel> {
    const url = this.baseUrl + '/api/v1/Security/LoginAs';
    const content = JSON.stringify(model);
    const response = await this.http.fetch(url, await this.transformOptions(this.getPostOptions(content)));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
    return await response.json();
  }

  logout(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/Logout';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLogout(_response);
      });
  }

  updateUserLatestLoginCompanyId(model: LastLoginCompanyModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/UpdateUserLatestLoginCompanyId';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  acceptNewTermsAndConditions(newTermsAndConditionsAccepted: boolean): Promise<Date> {
    let url_ = this.baseUrl + '/api/v1/Security/AcceptNewTermsAndConditions';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getPutOptions(newTermsAndConditionsAccepted.toString());

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<Date>(_response);
      });
  }

  protected processLogout(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  register(model: RegisterModel, theme: string | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/Register/{theme}';
    url_ = url_.replace('{theme}', encodeURIComponent('' + theme));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRegister(_response);
      });
  }

  protected processRegister(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  confirmEmail(model: ConfirmEmailModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/ConfirmEmail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  sendConfirmEmail(model: SendConfirmEmailModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/SendConfirmEmail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  forgotPassword(model: ForgotPasswordModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/ForgotPassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  resetPassword(model: ResetPasswordModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Security/ResetPassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processResetPassword(_response);
      });
  }

  protected processResetPassword(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  validateResetPasswordToken = async (data: { userName: string; token: string }, params: BaseQueryParams) => {
    await axiosInstance.post<void>('/api/v1/Security/ValidateResetPasswordToken', data, params);
  };

  getCompaniesForLicenseeAdmin(): Promise<string[]> {
    let url_ = this.baseUrl + '/api/v1/Licensee/companies';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCompaniesForLicenseeAdmin(_response);
      });
  }
  protected processCompaniesForLicenseeAdmin(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string[]>(<any>null);
  }

  async updateUserName(model: UpdateUserNameModel) {
    const url = `${this.baseUrl}/api/v1/Security/UserName`;
    const content = JSON.stringify(model);
    const response = await this.http.fetch(url, await this.transformOptions(this.getPutOptions(content)));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }

  async validateEmail(email: string) {
    let url_ = `${this.baseUrl}/api/v1/Security/ValidateEmail?email=${encodeURIComponent(email)}`;
    url_ = url_.replace(/[?&]$/, '');

    let options_ = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };
    const response = await this.http.fetch(url_, await this.transformOptions(options_));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }

  async sendEmailUpdateVerificationCode(newEmailAddress: string) {
    let url_ = `${this.baseUrl}/api/v1/Security/SendEmailUpdateVerificationCode?newEmailAddress=${encodeURIComponent(
      newEmailAddress
    )}`;
    url_ = url_.replace(/[?&]$/, '');
    const options_ = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };
    const response = await this.http.fetch(url_, await this.transformOptions(options_));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }

  async validateEmailUpdateVerificationCode(verificationCode: string): Promise<boolean> {
    let url_ = `${this.baseUrl}/api/v1/Security/ValidateEmailUpdateVerificationCode`;
    const options_ = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(verificationCode),
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<boolean>(_response);
      });
  }

  async updateUserEmail(model: UpdateUserEmailModel) {
    const url = `${this.baseUrl}/api/v1/Security/UpdateUserEmail`;
    const content = JSON.stringify(model);
    const response = await this.http.fetch(url, await this.transformOptions(this.getPutOptions(content)));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }
}

export interface IUsersClient {
  getAll(): Promise<UserModel[]>;
  get(id: string): Promise<UserModel>;
  updateUser(id: string, user: UserModel): Promise<void>;
  deleteUser(id: string): Promise<void>;
  find(name: string | null | undefined, email: string | null | undefined): Promise<UserModel[]>;
}

export class UsersClient extends BaseClient implements IUsersClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(): Promise<UserModel[]> {
    let url_ = this.baseUrl + '/api/v1/Users';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<UserModel[]>(_response);
      });
  }

  get(id: string): Promise<UserModel> {
    let url_ = this.baseUrl + '/api/v1/Users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<UserModel>(_response);
      });
  }

  updateUser(id: string, user: UserModel): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(user);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  deleteUser(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  find(name: string | null | undefined, email: string | null | undefined): Promise<UserModel[]> {
    let url_ = this.baseUrl + '/api/v1/Users/Find?';
    if (name !== undefined && name !== null) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
    if (email !== undefined && email !== null) url_ += 'Email=' + encodeURIComponent('' + email) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<UserModel[]>(_response);
      });
  }
}

export interface IDownstreamClient {
  getEPD(code: string | null, format: string | null): Promise<string>;
  getEPDFormats(): Promise<string>;
  getLCAs(): Promise<CountryModel[]>;
  getLCA(code: string | null | undefined, id: string): Promise<CountryModel>;
  getPCR(code: string | null): Promise<PCRModel>;
  getCountries(): Promise<ApiCountryModel[]>;
  getCountry(code: string | null): Promise<ApiCountryModel>;
  getAll(
    smartFilter: string | null | undefined,
    cPCLevel: CPCLevel | undefined,
    codes: string[] | null | undefined
  ): Promise<CPCModel[]>;
  getTree(): Promise<CPCTreeModel>;
  getAll2(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    withMembership: boolean | undefined,
    countryId: string | null | undefined
  ): Promise<CompanyModel[]>;
  get(id: string): Promise<CompanyModel>;
  getOrganizationTypes(): Promise<string>;
}

export class DownstreamClient extends BaseClient implements IDownstreamClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getEPD(code: string | null, format: string | null): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Downstream/epds/{code}/{format}';
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    if (format === undefined || format === null) throw new Error("The parameter 'format' must be defined.");
    url_ = url_.replace('{format}', encodeURIComponent('' + format));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }

  getEPDFormats(): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Downstream/epds/formats';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }

  getLCAs(): Promise<CountryModel[]> {
    let url_ = this.baseUrl + '/api/v1/Downstream/lcas';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CountryModel[]>(_response);
      });
  }

  getLCA(code: string | null | undefined, id: string): Promise<CountryModel> {
    let url_ = this.baseUrl + '/api/v1/Downstream/lcas/{id}?';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (code !== undefined && code !== null) url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CountryModel>(_response);
      });
  }

  getPCR(code: string | null): Promise<PCRModel> {
    let url_ = this.baseUrl + '/api/v1/Downstream/pcrs/{code}';
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<PCRModel>(_response);
      });
  }

  getCountries(): Promise<ApiCountryModel[]> {
    let url_ = this.baseUrl + '/api/v1/Downstream/countries';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<ApiCountryModel[]>(_response);
      });
  }

  getCountry(code: string | null): Promise<ApiCountryModel> {
    let url_ = this.baseUrl + '/api/v1/Downstream/countries/{code}';
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<ApiCountryModel>(_response);
      });
  }

  getAll(
    smartFilter: string | null | undefined,
    cPCLevel: CPCLevel | undefined,
    codes: string[] | null | undefined
  ): Promise<CPCModel[]> {
    let url_ = this.baseUrl + '/api/v1/Downstream/cpcs?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (cPCLevel === null) throw new Error("The parameter 'cPCLevel' cannot be null.");
    else if (cPCLevel !== undefined) url_ += 'CPCLevel=' + encodeURIComponent('' + cPCLevel) + '&';
    if (codes !== undefined && codes !== null)
      codes &&
        codes.forEach((item) => {
          url_ += 'Codes=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CPCModel[]>(_response);
      });
  }

  getTree(): Promise<CPCTreeModel> {
    let url_ = this.baseUrl + '/api/v1/Downstream/cpcs/tree';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CPCTreeModel>(_response);
      });
  }

  getAll2(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    withMembership: boolean | undefined,
    countryId: string | null | undefined
  ): Promise<CompanyModel[]> {
    let url_ = this.baseUrl + '/api/v1/Downstream/organizations?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyRoleId !== undefined && companyRoleId !== null)
      url_ += 'CompanyRoleId=' + encodeURIComponent('' + companyRoleId) + '&';
    if (withMembership === null) throw new Error("The parameter 'withMembership' cannot be null.");
    else if (withMembership !== undefined) url_ += 'WithMembership=' + encodeURIComponent('' + withMembership) + '&';
    if (countryId !== undefined && countryId !== null) url_ += 'CountryId=' + encodeURIComponent('' + countryId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CompanyModel[]>(_response);
      });
  }

  get(id: string): Promise<CompanyModel> {
    let url_ = this.baseUrl + '/api/v1/Downstream/organizations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CompanyModel>(_response);
      });
  }

  getOrganizationTypes(): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Downstream/organizations/types';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }
}

export interface IAdminLicenseesClient {
  getAll(): Promise<AdminLicenseeModel[]>;
  get(id: string): Promise<AdminLicenseeModel>;
  getCompanies(id: string): Promise<CompanyListModel[]>;
  create(createLicenseeModel: CreateLicenseeModel): Promise<AdminLicenseeModel>;
  update(id: string, updateLicenseeModel: UpdateLicenseeModel): Promise<AdminLicenseeModel>;
  delete(id: string): Promise<void>;
}

export class AdminLicenseesClient extends BaseClient implements IAdminLicenseesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(): Promise<AdminLicenseeModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAll(_response);
      });
  }

  protected processGetAll(response: Response): Promise<AdminLicenseeModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <AdminLicenseeModel[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AdminLicenseeModel[]>(<any>null);
  }

  get(id: string): Promise<AdminLicenseeModel> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<AdminLicenseeModel>(_response);
      });
  }

  getCompanies(id: string): Promise<CompanyListModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee/{id}/companies';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CompanyListModel[]>(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }

  create(data: CreateLicenseeModel): Promise<AdminLicenseeModel> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<AdminLicenseeModel>(_response);
      });
  }

  update(id: string, data: UpdateLicenseeModel): Promise<AdminLicenseeModel> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminLicensee/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<AdminLicenseeModel>(_response);
      });
  }

  updateLicenseeWithImage = async (licenseeId: string, formData: FormData) => {
    let url_ = this.baseUrl + `/api/admin/v1/AdminLicensee/${encodeURIComponent(licenseeId)}/with-image`;
    url_ = url_.replace(/[?&]$/, '');

    let options_ = {
      method: 'PUT',
      body: formData,
      headers: {
        Accept: 'application/json',
        // Don't manually set Content-Type here when using FormData
        // Content-Type: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<AdminLicenseeModel>(_response);
      });
  };
}

export interface IAdminCompaniesClient {
  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    includeArchived: boolean | undefined,
    onlyHolding: boolean | undefined
  ): Promise<CompanyListModel[]>;
  get(id: string): Promise<CompanyModel2>;
  getLinkableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]>;
  getHoldingableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]>;
  update(id: string, updateCompanyModel: UpdateCompanyModel2): Promise<void>;
  setHoldingCompany(id: string, holdingCompanyId: string): Promise<void>;
}

export class AdminCompaniesClient extends BaseClient implements IAdminCompaniesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(
    smartFilter: string | null | undefined,
    companyRoleId: string | null | undefined,
    includeArchived: boolean | undefined,
    onlyHolding: boolean | undefined
  ): Promise<CompanyListModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyRoleId !== undefined && companyRoleId !== null)
      url_ += 'CompanyRoleId=' + encodeURIComponent('' + companyRoleId) + '&';
    if (includeArchived === null) throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined) url_ += 'IncludeArchived=' + encodeURIComponent('' + includeArchived) + '&';
    if (onlyHolding === null) throw new Error("The parameter 'onlyHolding' cannot be null.");
    else if (onlyHolding !== undefined) url_ += 'onlyHolding=' + encodeURIComponent('' + onlyHolding) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CompanyListModel[]>(_response);
      });
  }

  get(id: string): Promise<CompanyModel2> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<CompanyModel2>(_response);
      });
  }

  getLinkableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies/{id}/Linkable';
    url_ = url_.replace('{id}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<LinkedCompanyModel[]>(_response);
      });
  }

  getHoldingableCompanies(companyId: string | undefined): Promise<LinkedCompanyModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies/{id}/Holdingable';
    url_ = url_.replace('{id}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<LinkedCompanyModel[]>(_response);
      });
  }

  update(id: string, updateCompanyModel: UpdateCompanyModel2): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCompanyModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  setHoldingCompany(id: string, holdingCompanyId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCompanies/{id}/holding/{holdingId}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{holdingId}', encodeURIComponent('' + holdingCompanyId));
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(holdingCompanyId);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }
}

export interface IAdminCountriesClient {
  get(smartFilter: string | null | undefined): Promise<CountryModel3[]>;
}

export class AdminCountriesClient extends BaseClient implements IAdminCountriesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(smartFilter: string | null | undefined): Promise<CountryModel3[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminCountries?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<CountryModel3[]>(_response);
      });
  }
}

export interface IPublicInformationMessagesClient {
  get(): Promise<string>;
}

export class PublicInformationMessagesClient extends BaseClient implements IPublicInformationMessagesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(): Promise<string> {
    let url_ = this.baseUrl + '/api/admin/v1/PublicInformationMessages';
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(<any>null);
  }
}

export interface IAdminEmailsClient {
  test(target: string | null | undefined): Promise<void>;
}

export class AdminEmailsClient extends BaseClient implements IAdminEmailsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  test(target: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminEmails/Test?';
    if (target !== undefined && target !== null) url_ += 'target=' + encodeURIComponent('' + target) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }
}

export interface IAdminEPDsClient {
  move(id: string, moveEPDModel: MoveEPDModel): Promise<void>;
}

export class AdminEPDsClient extends BaseClient implements IAdminEPDsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  move(id: string, moveEPDModel: MoveEPDModel): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminEPDs/{id}/Move';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(moveEPDModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }
}

export interface IAdminInvoicesClient {
  get(
    invoiceNumber: string | null | undefined,
    smartFilter: string | null | undefined,
    companyId: string | null | undefined,
    periods: string[] | null | undefined,
    invoiceStatuses: InvoiceStatus[] | null | undefined
  ): Promise<InvoiceListModel[]>;
  put(id: string, updateInvoiceModel: UpdateInvoiceModel): Promise<InvoiceModel2>;
  generate(): Promise<void>;
  createInvoice(createInvoiceModel: CreateInvoiceModel): Promise<void>;
  restoreInvoice(invoiceId: string | undefined): Promise<void>;
  send(code: string | null | undefined): Promise<void>;
  sendAsPdf(code: string | null | undefined): Promise<void>;
  sendApprovalReminder(invoiceId: string | undefined): Promise<void>;
  sendPaymentReminder(invoiceId: string | undefined): Promise<void>;
  testVisma(): Promise<void>;
  updateInvoiceStatuses(): Promise<void>;
}

export class AdminInvoicesClient extends BaseClient implements IAdminInvoicesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(
    invoiceNumber: string | null | undefined,
    smartFilter: string | null | undefined,
    companyId: string | null | undefined,
    periods: string[] | null | undefined,
    invoiceStatuses: InvoiceStatus[] | null | undefined
  ): Promise<InvoiceListModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices?';
    if (invoiceNumber !== undefined && invoiceNumber !== null)
      url_ += 'InvoiceNumber=' + encodeURIComponent('' + invoiceNumber) + '&';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (companyId !== undefined && companyId !== null) url_ += 'CompanyId=' + encodeURIComponent('' + companyId) + '&';
    if (periods !== undefined && periods !== null)
      periods &&
        periods.forEach((item) => {
          url_ += 'Periods=' + encodeURIComponent('' + item) + '&';
        });
    if (invoiceStatuses !== undefined && invoiceStatuses !== null)
      invoiceStatuses &&
        invoiceStatuses.forEach((item) => {
          url_ += 'InvoiceStatuses=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<InvoiceListModel[]>(_response);
      });
  }

  put(id: string, updateInvoiceModel: UpdateInvoiceModel): Promise<InvoiceModel2> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateInvoiceModel);

    let options_ = this.getPutOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessUpdate<InvoiceItemModel2>(_response);
      });
  }

  generate(): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/Generate';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  createInvoice(createInvoiceModel: CreateInvoiceModel): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/Create';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createInvoiceModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  restoreInvoice(invoiceId: string | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/Restore?';
    if (invoiceId === null) throw new Error("The parameter 'invoiceId' cannot be null.");
    else if (invoiceId !== undefined) url_ += 'invoiceId=' + encodeURIComponent('' + invoiceId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  send(code: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/Send?';
    if (code !== undefined && code !== null) url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  sendAsPdf(code: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/SendAsPdf?';
    if (code !== undefined && code !== null) url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  sendApprovalReminder(invoiceId: string | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/SendApprovalReminder?';
    if (invoiceId === null) throw new Error("The parameter 'invoiceId' cannot be null.");
    else if (invoiceId !== undefined) url_ += 'invoiceId=' + encodeURIComponent('' + invoiceId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  sendPaymentReminder(invoiceId: string | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/SendPaymentReminder?';
    if (invoiceId === null) throw new Error("The parameter 'invoiceId' cannot be null.");
    else if (invoiceId !== undefined) url_ += 'invoiceId=' + encodeURIComponent('' + invoiceId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  testVisma(): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/TestVisma';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }

  updateInvoiceStatuses(): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminInvoices/UpdateInvoiceStatuses';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.voidProcessPut(_response);
      });
  }
}

export interface IAdminKPIsClient {
  get(): Promise<KPIModel[]>;
}

export class AdminKPIsClient extends BaseClient implements IAdminKPIsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(): Promise<KPIModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminKPIs';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<KPIModel[]>(_response);
      });
  }
}

export interface IAdminPCRsClient {
  getAll(
    smartFilter: string | null | undefined,
    pCRStatus: PCRStatus | null | undefined,
    pCRTypeSelection: PCRTypeSelection | undefined,
    productCategoryId: string | null | undefined
  ): Promise<PCRModel2[]>;
  get(id: string): Promise<PCRModel2>;
}

export class AdminPCRsClient extends BaseClient implements IAdminPCRsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(
    smartFilter: string | null | undefined,
    pCRStatus: PCRStatus | null | undefined,
    pCRTypeSelection: PCRTypeSelection | undefined,
    productCategoryId: string | null | undefined
  ): Promise<PCRModel2[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminPCRs?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (pCRStatus !== undefined && pCRStatus !== null) url_ += 'PCRStatus=' + encodeURIComponent('' + pCRStatus) + '&';
    if (pCRTypeSelection === null) throw new Error("The parameter 'pCRTypeSelection' cannot be null.");
    else if (pCRTypeSelection !== undefined) url_ += 'PCRTypeSelection=' + encodeURIComponent('' + pCRTypeSelection) + '&';
    if (productCategoryId !== undefined && productCategoryId !== null)
      url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<PCRModel2[]>(_response);
      });
  }

  get(id: string): Promise<PCRModel2> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminPCRs/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<PCRModel2>(_response);
      });
  }
}

export class AdminDataSourcesClient extends BaseClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(smartFilter: string | null | undefined): Promise<DataSourceModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSources?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DataSourceModel[]>(_response);
      });
  }

  create(createPCRModel: CreatePCRModel2): Promise<PCRModel2> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSources';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPCRModel);

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessCreate<PCRModel2>(_response);
      });
  }

  get(id: string): Promise<DataSourceModel> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<DataSourceModel>(_response);
      });
  }

  update(id: string, data: any): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = this.getPutOptionsNoAccept(content_);
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessDelete(_response);
      });
  }
}

export interface IAdminDataSourceVersionsClient {
  getByDataSource(dataSourceId: string): Promise<DataSourceVersionModel[]>;
}

export class AdminDataSourceVersionsClient extends BaseClient implements IAdminDataSourceVersionsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getByDataSource(dataSourceId: string): Promise<DataSourceVersionModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminDataSourceVersions/{dataSourceId}';
    if (dataSourceId === undefined || dataSourceId === null)
      throw new Error("The parameter 'dataSourceId' must be defined.");
    url_ = url_.replace('{dataSourceId}', encodeURIComponent('' + dataSourceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<DataSourceVersionModel[]>(_response);
      });
  }
}

export interface IAdminRolesClient {
  get(): Promise<RoleModel[]>;
}

export class AdminRolesClient extends BaseClient implements IAdminRolesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(): Promise<RoleModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminRoles';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<RoleModel[]>(_response);
      });
  }
}

export interface IAdminUsersClient {
  getAll(smartFilter: string | null | undefined, includeArchived: boolean | null | undefined): Promise<UserListModel[]>;
  get(id: string): Promise<UserModel2>;
  update(id: string, updateUserModel: UpdateUserModel): Promise<void>;
  setPassword(id: string, setUserPasswordModel: SetUserPasswordModel): Promise<void>;
}

export class AdminUsersClient extends BaseClient implements IAdminUsersClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getAll(smartFilter: string | null | undefined, includeArchived: boolean | null | undefined): Promise<UserListModel[]> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminUsers?';
    if (smartFilter !== undefined && smartFilter !== null)
      url_ += 'SmartFilter=' + encodeURIComponent('' + smartFilter) + '&';
    if (includeArchived === null) throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined) url_ += 'IncludeArchived=' + encodeURIComponent('' + includeArchived) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<UserListModel[]>(_response);
      });
  }

  get(id: string): Promise<UserModel2> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminUsers/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<UserModel2>(_response);
      });
  }

  update(id: string, updateUserModel: UpdateUserModel): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminUsers/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateUserModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  setPassword(id: string, setUserPasswordModel: SetUserPasswordModel): Promise<void> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminUsers/{id}/password';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(setUserPasswordModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }
}

export interface IAdminVerifiersClient {
  downloadReviewOfVerifiers(fromDate: Date | undefined, toDate: Date | undefined): Promise<string>;
}

export class AdminVerifiersClient extends BaseClient implements IAdminVerifiersClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  downloadReviewOfVerifiers(fromDate: Date | undefined, toDate: Date | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/admin/v1/AdminVerifiers/DownloadReviewOfVerifiers?';
    if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toJSON() : '') + '&';
    if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }
}

export interface IAdminEPDsReportClient {
  downloadEPDsReport(fromDate: Date | undefined, toDate: Date | undefined): Promise<string>;
}

export class AdminEPDsReportClient extends BaseClient implements IAdminEPDsReportClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  downloadEPDsReport(fromDate: Date | undefined, toDate: Date | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/admin/v1/EPDsReport/DownloadEpdsReport?';
    if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toJSON() : '') + '&';
    if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }
}

export interface IUploadDocumentTypesClient {
  getDocumentTypes(): Promise<UploadDocumentTypesModel[]>;
}

export class UploadDocumentTypesClient extends BaseClient implements IUploadDocumentTypesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  getDocumentTypes(isForCompiler: boolean = false): Promise<UploadDocumentTypesModel[]> {
    let url_ = this.baseUrl + '/api/v1/UploadDocumentTypes?';
    if (isForCompiler) {
      url_ += 'IsForCompiler=true&';
    }
    url_ = url_.replace(/[?&]$/, '');
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDocumentTypes(_response);
      });
  }

  protected processGetDocumentTypes(response: Response): Promise<UploadDocumentTypesModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : <UploadDocumentTypesModel[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UploadDocumentTypesModel[]>(<any>null);
  }
}

//
export interface AccountModel {
  id?: string;
  name?: string | undefined;
  companyId?: string;
  companyName?: string | undefined;
  accountManagerUserId?: string;
  accountManagerName?: string | undefined;
  accountManagerEmail?: string | undefined;
  hasValidEPDProcessCertificate?: boolean;
  epdProcessCertificateUrl?: string | undefined;
  epdProcessCertificationExpirationDate?: Date;
  invoices?: InvoiceModel[] | undefined;
}

export interface AddressModel {
  line1?: string | undefined;
  line2?: string | undefined;
  line3?: string | undefined;
  line4?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  countryId?: string | undefined;
}

export enum InvoicingDeliveryMethod {
  Electronic = 'Electronic via e-mail',
  Letter = 'Via letter',
}

export interface InvoiceModel {
  id?: string;
  vismaId?: number;
  customerNumber?: string | undefined;
  period?: string | undefined;
  fromDate?: Date;
  toDate?: Date;
  subTotal?: number;
  totalVAT?: number;
  roundOff?: number;
  totalAmount?: number;
  currency?: string | undefined;
  companyName?: string | undefined;
  accountName?: string | undefined;
  reference?: string | undefined;
  invoicingAddress?: AddressModel | undefined;
  invoicingEmail?: string | undefined;
  invoicingNotes?: string | undefined;
  invoiceStatus?: InvoiceStatus;
  vat?: string | undefined;
  invoiceDate?: Date | undefined;
  dueDate?: Date | undefined;
  information?: string | undefined;
  termsOfPayment?: string | undefined;
  ourReference?: string | undefined;
  invoiceItems?: InvoiceItemModel[] | undefined;
}

export enum InvoiceStatus {
  Draft = 'Quotation',
  Approved = 'Approved',
  Credited = 'Credited',
  Declined = 'Declined',
  Paid = 'Paid',
  Sent = 'Sent',
}

export interface InvoiceItemModel {
  id?: string;
  code?: string | undefined;
  description?: string | undefined;
  hasVAT?: boolean;
  amount?: number | undefined;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  extensions?: { [key: string]: any };
}

export interface Account {
  id?: string;
  companyId: string;
  company?: Company | undefined;
  accountManagerUserId: string;
  accountManagerUser?: User | undefined;
  name?: string | undefined;
  currency?: string | undefined;
  paymentMethod?: string | undefined;
  paymentTerms?: number | undefined;
  reference?: string | undefined;
  invoicingAddress?: Address | undefined;
  countryId?: string | undefined;
  country?: Country | undefined;
  invoicingEmail?: string | undefined;
  invoicingNotes?: string | undefined;
  vismaCustomerNumber?: number | undefined;
}

export interface Company {
  id?: string;
  name?: string | undefined;
  abbreviation?: string | undefined;
  address?: Address | undefined;
  countryId?: string | undefined;
  country?: Country | undefined;
  website?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  companySize?: CompanySize;
  //vat?: string | undefined;
  verifierType?: VerifierType;
  accreditedBy?: string | undefined;
  hasToolVerificationType?: boolean;
  hasEPDProcessCertification?: boolean;
  enabled?: boolean;
  manualInvoicing?: boolean;
  logotype?: string | undefined;
  parentCompanyId?: string | undefined;
  parentCompany?: Company | undefined;
  emailNotifications?: boolean;
  adminNotes?: string | undefined;
  childCompanies?: Company[] | undefined;
  accounts?: Account[] | undefined;
  companyRoles?: CompanyRole[] | undefined;
  companyCountries?: CompanyCountry[] | undefined;
  memberships?: Membership[] | undefined;
  invitations?: Invitation[] | undefined;
  requests?: Request[] | undefined;
}

export interface ValueObject {}

export interface Address extends ValueObject {
  line1?: string | undefined;
  line2?: string | undefined;
  line3?: string | undefined;
  line4?: string | undefined;
  country?: string | undefined;
}

export interface Country {
  id?: string;
  name?: string | undefined;
  alpha2Code?: string | undefined;
  alpha3Code?: string | undefined;
  numericCode?: string | undefined;
  companyCountries?: CompanyCountry[] | undefined;
}

export interface CompanyCountry {
  id?: string;
  companyId: string;
  company?: Company | undefined;
  countryId: string;
  country?: Country | undefined;
}

export enum BillingStatus {
  Ok = 'Ok',
  Warning = 'Warning',
  Enforcement = 'Enforcement',
}

export enum CompanySize {
  NotApplicable = 'Not applicable',
  IndustryAssociation = 'Industry association',
  Large = 'Large enterprise (MNE, 250 or more employees)',
  Medium = 'Medium enterprise (50–249 employees)',
  Small = 'Small enterprise (10–49 employees)',
  Micro = 'Micro enterprise (1–9 employees)',
}

export enum VerifierType {
  Missing = 'Missing',
  Body = 'Accredited Certification Body',
  Individual = 'Approved Individual Verifier',
}

export enum DeveloperType {
  None = 'None',
  Internal = 'Internal',
  External = 'External',
}

export interface CompanyRole {
  id?: string;
  companyId: string;
  company?: Company | undefined;
  roleId: string;
  role?: Role | undefined;
  serviceProvider?: boolean;
}

export interface IdentityRoleOfGuid {
  id?: string;
  name?: string | undefined;
  normalizedName?: string | undefined;
  concurrencyStamp?: string | undefined;
}

export interface Role extends IdentityRoleOfGuid {
  id?: string;
  description?: string | undefined;
}

export interface Membership {
  id?: string;
  providerMembershipId?: string | undefined;
  providerMembership?: Membership | undefined;
  companyId: string;
  company?: Company | undefined;
  userId: string;
  user?: User | undefined;
  roleId: string;
  role?: Role | undefined;
  showOnEnvirondec?: boolean;
}

export interface IdentityUserOfGuid {
  id?: string;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;
}

export interface User extends IdentityUserOfGuid {
  firstName?: string | undefined;
  lastName?: string | undefined;
  name?: string | undefined;
  agreedToTermsDate?: Date | undefined;
  latestLoginDate?: Date | undefined;
  enabled?: boolean;
  emailConfirmed?: boolean;
  isLockedOut?: boolean;
  memberships?: Membership[] | undefined;
  accounts?: Account[] | undefined;
  userRoles?: UserRole[] | undefined;
}

export interface IdentityUserRoleOfGuid {
  userId?: string;
  roleId?: string;
}

export interface UserRole extends IdentityUserRoleOfGuid {
  user?: User | undefined;
  role?: Role | undefined;
}

export interface Invitation {
  id?: string;
  companyId: string;
  company?: Company | undefined;
  roleId: string;
  role?: Role | undefined;
  hostingUserId: string;
  hostingUser?: User | undefined;
  invitedUserEmail?: string | undefined;
  asGuest?: boolean;
  message?: string | undefined;
  expirationDate?: Date;
}

export interface Request {
  id?: string;
  companyId: string;
  company?: Company | undefined;
  roleId: string;
  role?: Role | undefined;
  requestingUserId: string;
  requestingUser?: User | undefined;
  asGuest?: boolean;
  message?: string | undefined;
}

export interface ModelStateDictionary {
  Root?: ModelStateEntry;
  MaxAllowedErrors?: number;
  HasReachedMaxErrors?: boolean;
  ErrorCount?: number;
  Count?: number;
  Keys?: any[];
  Values?: any[];
  IsValid?: boolean;
  ValidationState?: ModelValidationState;
  Item?: ModelStateEntry | undefined;
}

export interface ModelStateEntry {
  rawValue?: any | undefined;
  attemptedValue?: string | undefined;
  errors?: ModelError[];
  validationState?: ModelValidationState;
}

export interface ModelError {
  exception?: Exception | undefined;
  errorMessage?: string;
}

export interface Exception {
  Message?: string;
  InnerException?: Exception | undefined;
  Source?: string | undefined;
  StackTrace?: string | undefined;
}

export enum ModelValidationState {
  Unvalidated = 'Unvalidated',
  Invalid = 'Invalid',
  Valid = 'Valid',
  Skipped = 'Skipped',
}

export interface CreateAccountModel {
  name?: string | undefined;
  companyId?: string;
  accountMangerUserId?: string;
  invoicingEmail?: string | undefined;
  invoicingNotes?: string | undefined;
}

export interface UpdateAccountModel {
  id?: string;
  name?: string | undefined;
  accountManagerUserId?: string;
  currency?: string | undefined;
  paymentMethod?: string | undefined;
  reference?: string | undefined;
  invoicingAddress?: AddressModel | undefined;
  invoicingEmail?: string | undefined;
  invoicingNotes?: string | undefined;
  invoicingDeliveryMethod?: InvoicingDeliveryMethod;
}

export interface AccountSummaryModel {
  summaryItems?: SummaryItemModel[] | undefined;
}

export interface SummaryItemModel {
  count?: number;
  text?: string | undefined;
}

export interface CollectionStateModel {
  publishCollection: ActionState;
  deleteCollection: ActionState;
  saveCollection: ActionState;
  depublishCollection: ActionState;
  editCollection: ActionState;
}

export interface CollectionModel {
  id?: string | undefined | null;
  friendlyUrl?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  epdOwner?: EPDOwnerModel | undefined;
  image?: FileModel | undefined | null;
  documents?: FileModel[] | undefined;
  epds: CollectionEPDModel[];
  status: EPDCollectionStatus;
  hasPublishedEPDs?: boolean;
  collectionState?: CollectionStateModel;
}
export interface SaveCollectionModel {
  id?: string;
  companyd?: string;
  name?: string | undefined;
  description?: string | undefined;
  image?: FileModel | undefined;
  epdIds?: string[] | undefined;
}

export interface CollectionDashboardModel {
  id?: string;
  name?: string | undefined;
  image?: FileModel | undefined;
  createdAt: Date | undefined;
  modifiedAt: Date | undefined;
  friendlyUrl?: string | undefined;
  status?: EPDCollectionStatus | undefined;
  hasPublishedEPDs?: boolean;
}

export interface EPDOwnerModel {
  contactUserId?: string;
  contactName?: string | undefined;
  contactEmail?: string | undefined;
  companyId?: string;
  companyName?: string | undefined;
  companyHomeCountry?: string | undefined;
  address?: AddressModel | undefined;
  website?: string | undefined;
  logotypeFileId?: string | undefined;
}

export interface FileModel {
  id?: string;
  name?: string | undefined;
  isRemovable?: boolean;
}

export interface FileModelPlus {
  id?: string;
  name?: string | undefined;
  modifiedAt?: Date;
  epdFileId?: string;
}

export interface CollectionEPDModel {
  id: string;
  fullNumber: string;
  name: string;
  statusDisplayName: string;
  isDynamicForm?: boolean;
}

export enum EPDStatus {
  Reserved = 'Reserved',
  Registered = 'Registered',
  Deregistered = 'Deregistered',
}

export enum EPDStatusDisplayName {
  Reserved = 'reserved',
  SentForVerification = 'sentForVerification',
  DeclinedVerification = 'declinedVerification',
  ReadyToPublish = 'readyToPublish',
  Updating = 'updating',
  LicenseeReview = 'licenseeReview',
  SentForPublication = 'sentForPublication',
  DeclinedPublication = 'declinedPublication',
  Published = 'published',
  Depublished = 'depublished',
  Deregistered = 'deregistered',
}

export enum EPDCopyGroupStatus {
  Draft = 'Draft',
  Reserved = 'Reserved',
  SentForVerification = 'Sent for verification',
  Verified = 'Verified',
  SentForPublication = 'Sent for publication',
  SentForPublicationLicenseeAdmin = 'Licensee review',
  DeclinedCopyByLicenseeAdmin = 'Declined copy by Licensee Admin',
  DeclinedPublication = 'Declined publication',
}

export const EPDStatusDisplayNameToEPDCopyGroupStatusMapping: Record<EPDStatusDisplayName, EPDCopyGroupStatus | undefined> =
  {
    [EPDStatusDisplayName.Reserved]: EPDCopyGroupStatus.Reserved,
    [EPDStatusDisplayName.SentForVerification]: EPDCopyGroupStatus.SentForVerification,
    [EPDStatusDisplayName.DeclinedVerification]: undefined,
    [EPDStatusDisplayName.ReadyToPublish]: EPDCopyGroupStatus.Verified,
    [EPDStatusDisplayName.Updating]: undefined,
    [EPDStatusDisplayName.LicenseeReview]: EPDCopyGroupStatus.SentForPublicationLicenseeAdmin,
    [EPDStatusDisplayName.SentForPublication]: EPDCopyGroupStatus.SentForPublication,
    [EPDStatusDisplayName.DeclinedPublication]: EPDCopyGroupStatus.DeclinedPublication,
    [EPDStatusDisplayName.Published]: undefined,
    [EPDStatusDisplayName.Depublished]: undefined,
    [EPDStatusDisplayName.Deregistered]: undefined,
  };

export enum EPDCollectionStatus {
  None = 'None',
  Created = 'Created',
  Published = 'Published',
  Depublished = 'Depublished',
}

export interface AddCollectionEPDModel {
  collectionId?: string;
  propertyName?: string | undefined;
  newValue?: string;
}
export interface CompanyInvoiceInfoModel {
  invoiceOrganizationName?: string | undefined;
  invoiceAddressLine?: string | undefined;
  invoiceAddressLineSecond?: string | undefined;
  invoiceAddressCity?: string | undefined;
  invoiceAddressZipCode?: string | undefined;
  invoiceCountryId?: string | undefined;

  organizationAddressLine?: string | undefined;
  organizationAddressLineSecond?: string | undefined;
  organizationAddressCity?: string | undefined;
  organizationAddressZipCode?: string | undefined;
  organizationCountryId?: string | undefined;
  invoiceOrderingEmail?: string | undefined;
  invoiceRemindingEmail?: string | undefined;
  invoiceInvoicingEmail?: string | undefined;
  vat?: string | undefined;
  needDataUpdating: boolean;
}

export interface CompanyModel {
  id?: string;
  name?: string | undefined;
  settingsEnabled?: boolean;
  hasChangeNamePermissions?: boolean;
  address?: AddressModel | undefined;
  website?: string | undefined;
  organizationEmail?: string | undefined;
  phone?: string | undefined;
  companySize?: CompanySize;
  marketplace?: CountryModel3[] | undefined;
  gst?: string | undefined;
  abn?: string | undefined;
  memberships?: MembershipModel[] | undefined;
  accounts?: AccountModel[] | undefined;
  parentCompany?: LinkedCompanyModel | undefined;
  childCompanies?: LinkedCompanyModel[] | undefined;
  licenseesExclude?: boolean | undefined;
  isExcludedFromAutoDepublish?: boolean | undefined;
  isGlobalMarketplace?: boolean;

  invoiceOrganizationName?: string | undefined;
  invoiceAddressLine?: string | undefined;
  invoiceAddressLineSecond?: string | undefined;
  invoiceAddressCity?: string | undefined;
  invoiceAddressZipCode?: string | undefined;
  invoiceCountryId?: string | undefined;
  invoiceRegionId?: string | undefined;
  invoiceCcEmail?: string | undefined;
  isInvoiceUniquePurchaseOrderNumber?: string | undefined;
  isSpecialInvoiceNeeds?: string | undefined;
  specialInvoiceNeeds?: string | undefined;

  organizationAddressLine?: string | undefined;
  organizationAddressLineSecond?: string | undefined;
  organizationAddressCity?: string | undefined;
  organizationAddressZipCode?: string | undefined;
  invoiceCountryName?: string | undefined;
  organizationCountryId?: string | undefined;
  regionId?: string | null;
  invoiceOrderingEmail?: string | undefined;
  invoiceRemindingEmail?: string | undefined;
  invoicingEmail?: string | undefined;
  vat?: string | undefined;
  gln?: string | undefined;
  needDataUpdating?: boolean | undefined;
  reference?: string | undefined;
  hasToolVerificationType?: boolean;
  hasEPDProcessCertification?: boolean;
  roles?: string[] | undefined;
  isVerifierCertificationBody?: boolean | undefined;
  isMarketplaceEnabled?: boolean | undefined;
  isEpdOwner?: boolean | undefined;
  isLcaPractitioner?: boolean | undefined;
  preferredCurrency?: string | undefined;
  termsOfPayment?: string | undefined;
  invoiceCurrencyDialogDisplay?: boolean;
  billingStatus?: BillingStatus;
}

export interface CurrencySelectModel {
  preferredCurrencyOption: Option | null;
  invoiceCountryOption: Option | null;
}

export interface RegionSelectModel {
  invoiceCountryOption: Option | null;
  invoiceRegionOption: Option | null;
  countryOption: Option | null;
}

export interface MembershipModel {
  id: string;
  companyId: string;
  companyName: string | null;
  companyEnabled: boolean;
  userId: string;
  userName: string | null;
  userEmail: string | null;
  roleId: string;
  roleName: RoleName;
  isAccountManager: boolean;
  isHomeCompany: boolean | null;
  displayName: string;
}

export interface UserAdminLicenseesModel {
  id: string;
  licenseeId: string;
  licenseeName: string;
}

export interface InvitationModel {
  id?: string;
  asGuest?: boolean;
  message?: string | undefined;
  roleId?: string;
  roleName?: string | undefined;
  hostingUserId?: string;
  hostingUserName?: string | undefined;
  companyId?: string;
  companyName?: string | undefined;
  invitedUserEmail?: string | undefined;
  createdAt?: string | undefined;
}

export interface RequestModel {
  id?: string;
  asGuest?: boolean;
  message?: string | undefined;
  roleId?: string;
  roleName?: string | undefined;
  requestingUserId?: string;
  requestingUserName?: string | undefined;
  companyId?: string;
  companyName?: string | undefined;
  createdAt?: string | undefined;
}

export interface LinkedCompanyModel {
  id?: string;
  name?: string | undefined;
  enabled?: boolean;
}

export interface LicenseeModel {
  id: string;
  name: string;
  code: string;
  supportEmail: string;
  localHomepage: string;
}

export interface CreateLicenseeModel {
  name: string;
  countries: string[];
  users: string[];
  theme: string;
  supportEmail: string;
  localHomepage: string;
  hasVerifiersList: boolean;
  licenseeIndividualVerifiers: string[];
  licenseeCertificationBodyVerifiers: string[];
  logotypeUrl: string | null;
}

export interface UpdateLicenseeModel extends CreateLicenseeModel {
  id: string;
  removeLogo?: boolean;
}
export interface AdminLicenseeCountryModel {
  id: string;
  countryId: string;
  name: string;
}

export interface AdminLicenseeUserModel {
  id: string;
  userId: string;
  name: string;
}

export interface AdminLicenseeIndividualVerifierModel {
  id: string;
  name: string;
}

export interface AdminLicenseeModel {
  id: string;
  name: string;
  countries: AdminLicenseeCountryModel[];
  users: AdminLicenseeUserModel[];
  theme: string;
  supportEmail: string;
  localHomepage: string;
  hasVerifiersList: boolean;
  licenseeIndividualVerifiers: AdminLicenseeIndividualVerifierModel[];
  licenseeCertificationBodyVerifiers: AdminLicenseeIndividualVerifierModel[];
  licenseeLogo: string | undefined;
  removeLogo?: boolean;
}

export interface DeveloperCompanyModel {
  id?: string;
  name?: string | undefined;
  website?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  members?: MemberModel[] | undefined;
}

export interface MemberModel {
  membershipId?: string;
  userId?: string;
  email?: string | undefined;
  name?: string | undefined;
}

export interface VerifierModel {
  id?: string;
  name?: string | undefined;
  information?: string | undefined;
  verifierType?: VerifierType;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  logotypeFileId?: string | undefined;
}

export interface ConnectVerifierModel {
  epdId: string;
  certificationBodyCompanyId: string | null;
  individualVerifierMembershipId: string | null;
}

export interface CreateCompanyModel {
  name?: string | undefined;
  roleId?: string | undefined;
  website?: string | undefined;
  countryId?: string | undefined;
  regionId: string | null;
  vat: string | null;
  companySize?: CompanySize;
  organizationEmail?: string | undefined;
  isOnlyEmail?: boolean | undefined;
  addressLine?: string | undefined;
  addressLineSecond?: string | undefined;
  addressCity?: string | undefined;
  addressZipCode?: string | undefined;
  isCompanyAddressUsedForInvoice?: boolean | undefined;
  invoiceOrganizationName: string | null;
  invoiceCountryId: string | null;
  invoiceRegionId: string | null;
  invoiceAddressLine: string | null;
  invoiceAddressLineSecond: string | null;
  invoiceAddressCity: string | null;
  invoiceAddressZipCode: string | null;
  invoiceEmail: string | null;
  invoiceCcEmail: string | null;
  ordersEmail: string | null;
  remindersEmail: string | null;
  isInvoiceUniquePurchaseOrderNumber: string | null;
  isSpecialInvoiceNeeds: string | null;
  invoiceReference: string | null;
  specialInvoiceNeeds: string | null;
  countries?: CountryModel[] | undefined;
  isGlobalMarketplace?: boolean | undefined;
  preferredCurrency: string | null;
  gln: string | null;
  gst: string | null;
  abn: string | null;
}

export interface UpdateCompanyModel {
  id?: string;
  name?: string | undefined;
  address?: AddressModel | undefined;
  organizationEmail?: string | undefined;
  phone?: string | undefined;
  website?: string | undefined;
  companySize?: CompanySize;

  invoiceOrganizationName?: string | undefined;
  invoiceAddressLine?: string | undefined;
  invoiceAddressLineSecond?: string | undefined;
  invoiceAddressCity?: string | undefined;
  invoiceAddressZipCode?: string | undefined;
  invoiceCountryId?: string | undefined;

  organizationAddressLine?: string | undefined;
  organizationAddressLineSecond?: string | undefined;
  organizationAddressCity?: string | undefined;
  organizationAddressZipCode?: string | undefined;
  organizationCountryId?: string | undefined;
  invoiceOrderingEmail?: string | undefined;
  invoiceRemindingEmail?: string | undefined;
  invoicingEmail?: string | undefined;
  vat?: string | undefined;
  needDataUpdating?: boolean | undefined;
}

export interface UpdateCompanySettingsModel {
  id?: string;
  name?: string | undefined;
  address?: AddressModel | undefined;
  organizationEmail?: string | undefined;
  phone?: string | undefined;
  website?: string | undefined;
  companySize?: CompanySize;
  gst?: string | undefined;
  abn?: string | undefined;
  organizationAddressLine?: string | undefined;
  organizationAddressLineSecond?: string | undefined;
  organizationAddressCity?: string | undefined;
  organizationAddressZipCode?: string | undefined;
  organizationCountryId?: string | undefined;
  regionId?: string | null;
  marketplace?: CountryModel3[] | undefined;
  isGlobalMarketplace?: boolean;
  needDataUpdating?: boolean | undefined;
}

export interface UpdateCompanyInvoiceInfoModel {
  id?: string;
  invoiceOrganizationName?: string | undefined;
  invoiceAddressLine?: string | undefined;
  invoiceAddressLineSecond?: string | undefined;
  invoiceAddressCity?: string | undefined;
  invoiceAddressZipCode?: string | undefined;
  invoiceCountryId?: string | undefined;
  invoiceRegionId?: string | undefined;
  invoiceOrderingEmail?: string | undefined;
  invoiceRemindingEmail?: string | undefined;
  invoicingEmail?: string | undefined;
  invoiceCcEmail?: string | undefined;
  vat?: string | undefined;
  gln?: string | undefined;
  specialInvoiceNeeds?: string | undefined;
  reference?: string | undefined;
  isInvoiceUniquePurchaseOrderNumber?: string | undefined;
  isSpecialInvoiceNeeds?: string | undefined;
  preferredCurrency?: string | undefined;
  termsOfPayment?: string | undefined;
  needDataUpdating?: boolean | undefined;
}

export interface UpdateCompanyPropertyModel {
  companyId?: string;
  propertyName?: string | undefined;
  newValue?: any | undefined;
}

export interface CountryModel {
  id?: string;
  name?: string | undefined;
  alpha2Code?: string | undefined;
}

export interface RegionModel {
  id: string;
  name: string;
  alpha2Code: string;
  countryId: string;
  isMainRegion: boolean;
}

export interface LanguageModel {
  id: string;
  code: string;
  name: string;
}

export interface CPCModel {
  id?: string;
  code?: string | undefined;
  description?: string | undefined;
}

export enum CPCLevel {
  Section = 'Section',
  Division = 'Division',
  Group = 'Group',
  Classes = 'Classes',
  Subclasses = 'Subclasses',
}

export interface CPCTreeModel {
  nodes?: CPCNodeModel[] | undefined;
}

export interface CPCNodeModel {
  id?: string;
  level?: number;
  code?: string | undefined;
  description?: string | undefined;
  nodes?: CPCNodeModel[] | undefined;
}

export interface DataSourceModel {
  id?: string;
  name?: string | undefined;
  externalId?: string | undefined;
  isDisabled?: boolean;
}

export interface DataSourceVersionModel {
  id?: string;
  dataSourceId?: string;
  name?: string | undefined;
  externalId?: string | undefined;
  isDisabled?: boolean;
  isUsed?: boolean;
}

export interface EPDDataSourceModel {
  id?: string;
  dataSource: DataSourceModel;
  dataSourceVersion: DataSourceVersionModel;
  isMain: boolean;
}

export interface EPDModel {
  id?: string;
  versionId?: string;
  registrationNumber?: number | undefined;
  registrationNumberState: FieldState;
  shortIdentificationNumber?: string | undefined;
  fullIdentificationNumber?: string | undefined;
  versionNumber: number;
  firstPublishedVersionNumber?: number | undefined;
  deregistrationDate?: Date | undefined;
  deregistrationDateState: FieldState;
  validityDate?: string | undefined;
  validityDateState: FieldState;
  versionDate?: string | undefined;
  versionDateState: FieldState;
  status?: EPDStatus;
  statusState: FieldState;
  dataSetId?: string;
  dataSetIdState: FieldState;
  gtin?: string | undefined;
  gtinState: FieldState;
  uncpcCode?: CPCModel | undefined;
  uncpcCodeState: FieldState;
  isSectorEPD?: boolean;
  isSectorState: FieldState;
  isDualRegistration?: boolean;
  isDualRegistrationState: FieldState;
  isEcoPlatform?: boolean;
  ecoPlatformRegistrationNumber?: string | undefined;
  isEn15804Compliant?: boolean;
  referencePackageVersion15804?: string;
  referencePackageVersion15804State: FieldState;
  characterisationMethods?: string;
  characterisationMethodsState: FieldState;
  friendlyUrl?: string | undefined;
  languageCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  keywords?: string | undefined;
  title?: string | undefined;
  titleState: FieldState;
  collections?: CollectionListModel[] | undefined;
  collectionState: FieldState;
  productDescription?: string | undefined;
  productDescriptionState: FieldState;
  products?: string | undefined;
  productsState: FieldState;
  dataSets?: string | undefined;
  referenceFlow?: ReferenceFlowOldWizardModel;
  referenceFlowState: FieldState;
  conversionFactorToMass?: ConversionFactorToMassModel;
  conversionFactorToMassState: FieldState;
  massOfDeclaredUnit: number | null;
  massOfDeclaredUnitState: FieldState;
  epdReferences?: string | undefined;
  epdReferencesState: FieldState;
  productCategoryIdState: FieldState;
  productCategoryId?: string | undefined;
  pcr?: PCRModel | undefined;
  pcrState: FieldState;
  cpcr?: PCRModel | undefined;
  cpcrState: FieldState;
  preverifiedToolVersion?: ToolVersionStandardEpdOptionModel | undefined;
  preverifiedToolVersionState: FieldState;
  preverifiedTool?: ToolStandardEpdOptionModel | undefined;
  preverifiedToolState: FieldState;
  account?: AccountModel | undefined;
  epdOwner?: EPDOwnerModel | undefined;
  epdOwnerState: FieldState;
  epdDevelopers?: EPDDeveloperModel[] | undefined;
  epdDevelopersState: FieldState;
  epdDevelopersAddOrInviteState: FieldState;
  epdVerifier?: EPDVerifierModel | undefined;
  epdVerifierState?: FieldState | undefined;
  contactPerson?: EPDDeveloperModel | undefined;
  contactPersonState?: FieldState | undefined;
  verificationTemplateUrlState?: FieldState | undefined;
  verificationReports?: FileModel[] | undefined;
  verificationReportsState?: FieldState | undefined;
  processCertificates?: FileModel[] | undefined;
  processCertificatesState?: FieldState | undefined;
  generateRegistrationCertificateState?: ActionState | undefined;
  documentTemplateUrlState?: FieldState | undefined;
  documents?: FileModel[] | undefined;
  documentsState: FieldState;
  lcaTemplateUrlState?: FieldState | undefined;
  lcAs?: FileModel[] | undefined;
  lcAsState: FieldState;
  covers?: FileModel[] | undefined;
  productImages?: FileModelPlus[] | undefined;
  productImagesState: FieldState;
  epdState?: EPDStateModel | undefined;
  materialProperties?: MaterialPropertyItemModel[] | undefined;
  materialPropertiesState?: FieldState | undefined;
  geographicalDescription?: string | undefined;
  geographicalDescriptionState?: FieldState | undefined;
  technologyDescription?: string | undefined;
  technologyDescriptionState?: FieldState | undefined;
  technicalPurpose?: string | undefined;
  technicalPurposeState?: FieldState | undefined;
  useAdvice?: string | undefined;
  useAdviceState?: FieldState | undefined;
  subtype?: Subtype;
  subtypeState?: FieldState | undefined;
  epdDataSources: EPDDataSourceModel[] | undefined;
  epdDataSourcesState: FieldState;
  geographicalScopes?: GeographicalScopeModel[] | undefined;
  geographicalScopesState: FieldState;
  statementOfConformityWithStandards?: string;
  statementOfConformityWithStandardsState: FieldState;
  approvalTimestamp: string | null;
  approvalTimestampState: FieldState;
  verificationType?: VerificationType;
  verificationTypeState: FieldState;
  isProtectedByCopyright?: boolean;
  isProtectedByCopyrightState: FieldState;
  licenseType?: LicenseType;
  licenseTypeState: FieldState;
  createdAt?: string;
  companyId: string;
  companyName?: string | undefined;
  versionState?: string | undefined;
  epdVerificationActionStates?: EPDCopyGroupActionStatesEPDVerificationModel | undefined;
  verificationDeclineReason?: string | undefined;
  serviceAgreementStatus?: boolean | undefined;
  publishedVersionId: string | undefined;
  isCompilerFormat: boolean;
  useOldUpdateFlow?: boolean;
  sentEmailsToContactPersonFlag: boolean;
  sentEmailsToContactPersonFlagState: FieldState;
  dateOfFirstRegistration?: Date | undefined;
  dateOfFirstPublication: string | null;
  firstPublishedVersionDate: string | null;
  firstPublishedVersionDateState: FieldState;
  epdBasedOnUnit?: string | undefined;
  epdBasedOnUnitState?: FieldState;
  functionalUnitDescription?: string | undefined;
  functionalUnitDescriptionState?: FieldState;
  productType?: string | undefined;
  productTypeState?: FieldState;
  biogenicCarbonContent?: BiogenicCarbonContentModel | undefined;
  lcaBasedDescription?: string | undefined;
  lcaBasedDescriptionState?: FieldState;
  requirePublicationOnOkobaudat?: string | undefined;
  requirePublicationOnOkobaudatState?: FieldState;
  okobaudatProductCategoryId: string | null;
  okobaudatProductCategoryIdState: FieldState;
  okobaudatProductSubCategoryId: string | null;
  okobaudatProductSubCategoryIdState: FieldState;
  okobaudatProductCategoryTypeId: string | null;
  okobaudatProductCategoryTypeIdState: FieldState;
  isOtherDatabaseUsedAsDatasource: boolean;
  isOtherDatabaseUsedAsDatasourceState: FieldState;
  otherDatabaseUsedAsDatasourceDescription: string | null;
  otherDatabaseUsedAsDatasourceDescriptionState: FieldState;
}

export interface EPDVerificationStatesModel {
  declineReason?: string | undefined;
  modelStates?: EPDCopyGroupActionStatesEPDVerificationModel | undefined;
  versionState?: string | undefined;
  verificationReports: FileModel[] | undefined;
  processCertificates: FileModel[] | undefined;
}

export interface EpdGroupDashboardModel {
  id: string;
  name: string | undefined;
  status: EPDCopyGroupStatus;
  itemsCount: number;
  createdAt: Date;
}

export interface EpdCopyGroupWizardModel {
  id: string | undefined;
  name: string | undefined;
  collectionId: string | undefined;
  status: EPDCopyGroupStatus | undefined;
  createdAt: Date | undefined;
  versionDate: string | null;
  validityDate: Date | undefined;
  count: number | undefined;
  sourceEpdVersionId: string | undefined;
  practitionersIds: string[] | undefined;
  verifierId: string | undefined;
  verificationType: VerificationType | undefined;
  preverifiedTool: Option | null;
  preverifiedToolVersion: Option | null;
  selectedKeywordsList: string[] | undefined;
  selectedDefinitionSectionsList: EpdDefinitionEnum[] | undefined;
  selectedProductInformationSectionsList: EpdProductInformationEnum[] | undefined;
  selectedMachineReadableSectionsList: EpdMachineReadableEnum[] | undefined;
  copyAllData: boolean | undefined;
  isSectorEPD: boolean | undefined;
  productCategoryId: string | undefined;
  pcr: PCRModel | undefined;
  cpcr: PCRModel | undefined;
  epds: EPDModel[] | undefined;
  verifiersSource: EPDVerifierModel[] | undefined;
  developersSource: MembershipModel[] | undefined;
  epdCopyGroupDataSources: EPDCopyGroupDataSourcesModel | undefined;
  groupState: EPDCopyGroupStateModel;
  processCertificatesFiles?: FileModel[] | undefined;
  isAgreementAccepted: boolean | undefined;
  verificationDeclineReason?: string | undefined;
  userRoles: UserRolesModel;
  statementOfConformityWithStandards: string | undefined;
  licenseeAdminReviewComment: string | undefined;
}

export interface UserRolesModel {
  userId: string;
  isAdmin: boolean;
  isLicenseeAdmin: boolean;
  isOwner: boolean;
  isPractitioner: boolean;
  isVerifier: boolean;
}

export interface EPDCopyGroupModel {
  id: string | undefined;
  name: string | undefined;
  versionDate: string | null;
  isAgreementAccepted: boolean | undefined;
  declineReason?: string | undefined;
}

export interface EPDDataToCopyAllModel {
  id: string | undefined;
  practitionersIds: string[];
  verifierId: string | undefined;
  verificationType: VerificationType | undefined;
  preverifiedTool: Option | null;
  preverifiedToolVersion: Option | null;
  selectedKeywordsList: string[] | undefined;
  isSectorEPD: boolean | undefined;
  pcr: PCRModel | undefined;
  cpcr: PCRModel | undefined;
  statementOfConformityWithStandards: string | undefined;
  productCategoryId: string | undefined;
  isCpcrCopied: boolean;
  isPcrCopied: boolean;
}

export interface EPDCopyGroupStateModel {
  delete: ActionState;
  startVerification: ActionState;
  cancelVerification: ActionState;
  confirmVerification: ActionState;
  retractVerification: ActionState;
  sendToPublish: ActionState;
  declineCopy: ActionState;
  cancelPublication: ActionState;
  publish: ActionState;
  licenseeAdminSendToPublish: ActionState;
  addNewCopy: ActionState;
  deleteEPDCopy: ActionState;
  lcaPractitionerState: ActionState;
  listEPDOnThirdTab: ActionState;
  listEPDThirdTabMessageForVerifier: ActionState;
  listEPDThirdTabMessageForOwner: ActionState;
  agreementAccepted: ActionState;
}

export interface EPDCopyGroupActionStatesEPDVerificationModel {
  approveVerification: ActionState;
  declineVerification: ActionState;
  uploadVerificationReport: ActionState;
  statusOfVerification: ActionState;
  additionalMenuInApproveStatus: ActionState;
  additionalMenuInDeclineStatus: ActionState;
}

export interface EPDCopyGroupFilesModel {
  processCertificatesFiles?: FileModel[] | undefined;
}

export interface DataSourceModel {
  id?: string;
  name?: string | undefined;
}

export interface FieldState {
  actionState: ActionState;
  mandatory: boolean;
  errorMessage?: string;
  errorSeverity?: string;
  modifiedAt?: Date | undefined;
  modifiedBy?: string | undefined;
}

export interface EPDCopyGroupDataSourcesModel {
  epdsToCopy: DataSourceModel[];
  collectionDataSource: DataSourceModel[];
  verificationTypeDataSource: VerificationType[];
  preverifiedToolDataSource: ToolStandardEpdOptionModel[];
  preverifiedToolVersionDataSource: ToolVersionStandardEpdOptionModel[];
  productInformationSectionDataSource: EpdProductInformationEnum[];
}

export enum EpdDefinitionEnum {
  SectorEpd = 'SectorEpd',
  KeyWords = 'KeyWords',
}

export enum EpdProductInformationEnum {
  ProductDescription = 'ProductDescription',
  Products = 'Products',
  Images = 'Images',
  GeographicalScope = 'GeographicalScope',
}

export enum EpdMachineReadableEnum {
  ReferenceFlows = 'ReferenceFlows',
  MaterialProperties = 'MaterialProperties',
  GeographicalScopeDescription = 'GeographicalScopeDescription',
  TechnologyDescription = 'TechnologyDescription',
  TechnicalPurposeOfProduct = 'TechnicalPurposeOfProduct',
  Subtype = 'Subtype',
  DataSources = 'DataSources',
  UseAdvice = 'UseAdvice',
  ReferencePackageVersion15804 = 'ReferencePackageVersion15804',
  CharacterisationMethods = 'CharacterisationMethods',
  EpdBasedOnUnit = 'EpdBasedOnUnit',
  ProductToDeclare = 'ProductToDeclare',
  BiogenicCarbonContent = 'BiogenicCarbonContent',
  AdditionalInformationAboutTheUnderlyingLCABasedInformation = 'AdditionalInformationAboutTheUnderlyingLCABasedInformation',
  ConversionFactorToMass = 'ConversionFactorToMass',
  MassOfDeclaredUnit = 'MassOfDeclaredUnit',
}

export enum VisibilityType {
  Hidden = 'Hidden',
  Edit = 'Enabled',
  Enabled = 'Enabled',
  Disabled = 'Disabled',
  StubVerifier = 'StubVerifier',
  Stub = 'Stub',
}

export enum ActionState {
  Hidden = 'Hidden',
  Enabled = 'Enabled',
  Disabled = 'Disabled',
  Locked = 'Locked',
  StubVerifier = 'StubVerifier',
  Stub = 'Stub',
}

export enum ElectricityEnum {
  TypeOfElectricityMix = 'typeOfElectricityMix',
  EnergySource = 'energySources',
  ClimateImpact = 'climateImpact',
}

export enum TypeOfElectricityMixEnum {
  Specific = '1',
  ResidualOfSupplierOnMarket = '2',
  ResidualOnMarket = '3',
}

export enum EnergySourceEnum {
  Hydro = 'Hydro',
  Wind = 'Wind',
  Solar = 'Solar',
  Biomass = 'Biomass',
  Waste = 'Waste',
  NaturalGas = 'NaturalGas',
  Coal = 'Coal',
  Oil = 'Oil',
  Peat = 'Peat',
  Other = 'Other',
  Geothermal = 'Geothermal',
  Nuclear = 'Nuclear',
}

export enum BiogasDataEnum {
  TypeOfBiogasMix = 'typeOfBiogasMix',
  ClimateImpactIntensity = 'climateImpactIntensity',
}
export interface CollectionListModel {
  id?: string;
  name?: string | undefined;
}

export interface PCRModel {
  version?: string | undefined;
  versionDate?: Date | undefined;
  id?: string;
  isBasicModule?: boolean;
  registrationNumber?: string | undefined;
  status?: PCRStatus;
  initiatedDate?: Date | undefined;
  startOpenConsultationDate?: Date | undefined;
  deadlineOpenConsultationDate?: Date | undefined;
  reviewAndApprovalDate?: Date | undefined;
  publicationDate?: Date | undefined;
  showUpdateInfoUntil?: Date | undefined;
  approvalDate?: Date | undefined;
  deregistrationDate?: Date | undefined;
  validUntil?: string | undefined;
  is15804Compliant?: boolean;
  isISO219302017Available?: boolean;
  isEN158042012A2Available?: boolean;
  isVisibleForCompiler?: boolean;
  isComplementary?: boolean;
  isCPCR22OrCPCR23Selected?: boolean;
  friendlyUrl?: string | undefined;
  languageCode?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  shortName?: string | undefined;
  combinedName?: string | undefined;
  cpcName?: string | undefined;
  text?: string | undefined;
  statusText?: string | undefined;
  description?: string | undefined;
  legalNote?: string | undefined;
  preparedBy?: string | undefined;
  contributors?: string | undefined;
  fileId?: string;
  documents?: FileModel[] | undefined;
  cpCs?: CPCModel[] | undefined;
  productCategories?: ProductCategoryModel[] | undefined;
  cpcrProductCategories?: ProductCategoryModel[] | undefined;
  isConstruction?: boolean;
}

export interface CopyEpdFormikModel {
  edpCopyGroupName?: string;
  sourceEpdVersionId?: string;
  collectionId?: string;
  practitionersIds: string[];
  verifierId?: string;
  singleCopy?: boolean;
  copyAllDataset?: boolean;
  productCategoryId: string;
  pcr: PCRModel;
  cpcr: PCRModel | undefined;
  count?: number | undefined;
  verificationType?: VerificationType;
  preverifiedToolId?: string;
  preverifiedToolVersionId?: string;
  keywordsList: string[];
  productInformationSectionsList?: EpdProductInformationEnum[];
  machineReadableSectionsList?: EpdMachineReadableEnum[];
  isSectorEPD: boolean;
}

export enum PCRStatus {
  None = 'None',
  UnderDevelopment = 'Under development',
  Registered = 'Registered',
  Deregistered = 'Deregistered',
}

export interface FindPCRsModel {
  smartFilter?: string | null;
  excludedSubstringFilter?: string | null;
  pcrStatusSelection?: PCRStatusSelection | null;
  productCategoryId?: string | null;
  isDisabled?: boolean | null;
  targetEPDFormat?: 'compiler';
  pcrType?: 'PCR' | 'CPCR' | null;
  mainPCRId?: string | null;
}

export interface ProductCategoryModel {
  id?: string;
  title?: string | undefined;
  productCategories?: ProductCategoryModel[] | undefined;
}

export interface EPDDeveloperModel {
  contactUserId?: string;
  contactName?: string | undefined;
  contactEmail?: string | undefined;
  companyId?: string;
  companyName?: string | undefined;
  address?: AddressModel | undefined;
  website?: string | undefined;
  logotypeFileId?: string | undefined;
}

export interface EPDVerifierModel {
  id: string;
  verifierType?: VerifierType;
  contactUserId: string;
  contactName: string;
  companyId: string;
  companyName: string;
  address?: AddressModel | undefined;
  website?: string | undefined;
  information?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  displayName?: string | undefined;
  logotypeFileId?: string | undefined;
  isExternalMembership?: string | undefined;
  companyAddress?: VerifierCompanyAddressModel;
}

export interface EPDStateModel {
  isMandatoryComplete: boolean;
  isEditorialUpdate: boolean;
  deleteDraft: ActionState;
  cancelUpdate: ActionState;
  startVerification: ActionState;
  retractVerification: ActionState;
  cancelVerification: ActionState;
  sendForPublication: ActionState;
  cancelPublication: ActionState;
  deregister: ActionState;
  unlock: ActionState;
  cancelDeregistration: ActionState;
  approveVerification: ActionState;
  declineVerification: ActionState;
  publish: ActionState;
  declinePublication: ActionState;
  depublishByAdmin: ActionState;
  depublishByCustomer: ActionState;
  sendForPublicationEditorial: ActionState;
  licenseeAdminSendToPublish: ActionState;
  downloadIlcdEpdBundle: ActionState;
  statusDisplayName: EPDStatusDisplayName;
  statusMessageCode: string;
  commentToStatus: string | null;
  licenseeAdminReviewComment: string | null;
}

export enum Subtype {
  Specific = 'Specific',
  Average = 'Average',
  Representative = 'Representative',
  Template = 'Template',
}

export interface ReferenceFlowOldWizardModel {
  name: string | null;
  flowPropertyId: string | null;
  conversionFactor: number | null;
}

export interface ConversionFactorToMassModel {
  conversionFactor: number | null;
}
export interface FlowPropertyItemModel {
  flowPropertyId?: string;
  conversionFactor?: number;
}

export interface MaterialPropertyItemModel {
  materialPropertyId?: string;
  value?: number;
}

export interface BiogenicCarbonContentModel {
  id?: string;
  doesProductContainMoreThan5Percent?: string | undefined;
  doesProductContainMoreThan5PercentState: FieldState;
  doesPackagingMaterialContainMoreThan5Percent?: string | undefined;
  doesPackagingMaterialContainMoreThan5PercentState: FieldState;
  productItem?: BiogenicCarbonContentItemModel;
  accompanyingPackageItem?: BiogenicCarbonContentItemModel;
}

export interface BiogenicCarbonContentItemModel {
  conversionFactor?: number;
  conversionFactorState: FieldState;
  unitKey?: string | undefined;
  unitKeyState: FieldState;
}

export interface GeographicalScopeModel {
  id?: string;
  name?: string | undefined;
}

export interface ProductClassificationModel {
  id?: string;
  productId?: string;
  productClassificationType?: number | null;
  description?: string;
  code?: string;
}

export enum VerificationType {
  EPDProcessCertification = 'EPDProcessCertification',
  EPDVerification = 'EPDVerification',
  EPDPreverifiedTool = 'FullyPreverifiedTool',
}

export enum VersionStateType {
  Draft = 'Draft',
  UnderReview = 'Under Review',
  Approved = 'Approved',
  SentForPublication = 'Sent for publication',
  SentForPublicationEditorial = 'Sent for publication editorial',
  Deregistered = 'Deregistered',
  Published = 'Published',
  DeclinedPublication = 'Declined publication',
  Depublished = 'De-published',
  SentForPublicationLicenseeReview = 'Licensee review',
  DeclinedVerification = 'Declined verification',
  EditorialUpdating = 'Editorial updating',
}

export enum LicenseType {
  Missing = 'Missing',
  FreeForAll = 'FreeForAll',
  FreeForMembersOnly = 'FreeForMembersOnly',
  FreeForSome = 'FreeForSome',
}

export interface CreateEPDModel {
  accountId?: string;
}

export interface CopyEpdModel {
  epdId: string;
  accountId?: string;
  newEpdName: string;
  copyProperties?: any[];
  targetIsCompilerFormat?: boolean;
}

export interface MultiCopyEpdModel {
  epdId: string;
  accountId?: string;
  copyProperties?: any[];
  titles: string[];
  count: number;
}

export interface CopyEpdV2Model {
  companyId: string;
  edpCopyGroupName: string;
  sourceEpdVersionId: string;
  collectionId?: string;
  accountId: string;
  practitionersIds: string[];
  verifierId?: string;
  productCategoryId?: string;
  pcrId?: string;
  cpcrId?: string;
  count: number;
  definitionSectionsList: number[];
  productInformationSectionsList: number[];
  machineReadableSectionsList: number[];
  copyAllData?: boolean;
  statementOfConformityWithStandards: string[];
}

export interface UpdateEPDModel {
  id?: string;
  registrationNumber?: number;
  name?: string | undefined;
}

export interface UpdateEPDPropertyModel {
  epdId?: string;
  propertyName?: string | undefined;
  newValue?: any | undefined;
}

export interface UpdateEPDGroupPropertyModel {
  copyGroupId?: string;
  propertyName?: string | undefined;
  newValue?: any | undefined;
}

export interface SendForPublicationEditorialModel {
  epdId?: string;
  notes?: string | undefined;
}

export enum PCRStatusSelection {
  UnderDevelopment = 'Under development',
  Registered = 'Registered',
  Deregistered = 'Deregistered',
  All = 'All',
}

export enum PCRTypeSelection {
  BasicModule = 'BasicModule',
  PCR = 'PCR',
  All = 'All',
}

export interface EPDIndividualVerifierModel {
  id?: string;
  name?: string | undefined;
  companyName?: string | undefined;
}

export interface EPDCertificationBodyModel {
  id?: string;
  name?: string | undefined;
  accreditedBy?: string | undefined;
}

export interface DeveloperModel {
  id?: string;
  name?: string | undefined;
  website?: string | undefined;
}

export interface CountryModel2 {
  id?: string | undefined;
  name?: string | undefined;
}

export interface CreateInvitationModel {
  companyId?: string;
  roleId?: string;
  invitedUserEmail?: string | undefined;
  asGuest?: boolean;
  message?: string | undefined;
}

export interface InquireCollaborationModel {
  roleId?: string;
  companyId?: string;
}

export interface InvoiceSummaryModel {
  drafts?: InvoiceSummaryItemModel[] | undefined;
  invoices?: InvoiceSummaryItemModel[] | undefined;
}

export interface InvoiceSummaryItemModel {
  invoiceId?: string;
  name?: string | undefined;
  invoiceStatus?: InvoiceStatus;
}

export interface DeclineInvoiceModel {
  invoiceId: string;
  message: string;
}

export interface MaterialPropertyModel {
  id: string;
  fullName: string;
  unit: string;
  unitName: string;
}

export interface FlowPropertyModel {
  id: string;
  fullName: string;
  unit: string;
  unitName: string;
}

export interface CreateMembershipModel {
  companyId?: string;
  userId?: string;
  roleId?: string;
}

export enum HttpStatusCode {
  Continue = 'Continue',
  SwitchingProtocols = 'SwitchingProtocols',
  Processing = 'Processing',
  EarlyHints = 'EarlyHints',
  OK = 'OK',
  Created = 'Created',
  Accepted = 'Accepted',
  NonAuthoritativeInformation = 'NonAuthoritativeInformation',
  NoContent = 'NoContent',
  ResetContent = 'ResetContent',
  PartialContent = 'PartialContent',
  MultiStatus = 'MultiStatus',
  AlreadyReported = 'AlreadyReported',
  IMUsed = 'IMUsed',
  MultipleChoices = 'Ambiguous',
  Ambiguous = 'Ambiguous',
  MovedPermanently = 'Moved',
  Moved = 'Moved',
  Found = 'Redirect',
  Redirect = 'Redirect',
  SeeOther = 'RedirectMethod',
  RedirectMethod = 'RedirectMethod',
  NotModified = 'NotModified',
  UseProxy = 'UseProxy',
  Unused = 'Unused',
  TemporaryRedirect = 'TemporaryRedirect',
  RedirectKeepVerb = 'TemporaryRedirect',
  PermanentRedirect = 'PermanentRedirect',
  BadRequest = 'BadRequest',
  Unauthorized = 'Unauthorized',
  PaymentRequired = 'PaymentRequired',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  MethodNotAllowed = 'MethodNotAllowed',
  NotAcceptable = 'NotAcceptable',
  ProxyAuthenticationRequired = 'ProxyAuthenticationRequired',
  RequestTimeout = 'RequestTimeout',
  Conflict = 'Conflict',
  Gone = 'Gone',
  LengthRequired = 'LengthRequired',
  PreconditionFailed = 'PreconditionFailed',
  RequestEntityTooLarge = 'RequestEntityTooLarge',
  RequestUriTooLong = 'RequestUriTooLong',
  UnsupportedMediaType = 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
  ExpectationFailed = 'ExpectationFailed',
  MisdirectedRequest = 'MisdirectedRequest',
  UnprocessableEntity = 'UnprocessableEntity',
  Locked = 'Locked',
  FailedDependency = 'FailedDependency',
  UpgradeRequired = 'UpgradeRequired',
  PreconditionRequired = 'PreconditionRequired',
  TooManyRequests = 'TooManyRequests',
  RequestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons = 'UnavailableForLegalReasons',
  InternalServerError = 'InternalServerError',
  NotImplemented = 'NotImplemented',
  BadGateway = 'BadGateway',
  ServiceUnavailable = 'ServiceUnavailable',
  GatewayTimeout = 'GatewayTimeout',
  HttpVersionNotSupported = 'HttpVersionNotSupported',
  VariantAlsoNegotiates = 'VariantAlsoNegotiates',
  InsufficientStorage = 'InsufficientStorage',
  LoopDetected = 'LoopDetected',
  NotExtended = 'NotExtended',
  NetworkAuthenticationRequired = 'NetworkAuthenticationRequired',
}

export interface SignUpNewsletterModel {
  email: string;
  agreedOnTerms: boolean;
  token: string;
}

export interface CreatePCRModel {}

export interface UpdatePCRModel {
  id?: string;
  name?: string | undefined;
}

export interface UpdatePCRPropertyModel {
  pcrId?: string;
  propertyName?: string | undefined;
  newValue?: any | undefined;
}

export interface ProgramOperatorModel {
  id?: string;
  name?: string | undefined;
}

export interface CreateRequestModel {
  companyId?: string;
  roleId?: string;
  asGuest?: boolean;
  message?: string | undefined;
}

export interface RoleModel {
  id?: string;
  name?: string | undefined;
  description?: string | undefined;
  isDisplayedInMenu: boolean;
}

export interface VatValidation {
  name?: string | undefined;
  countryCode?: string | undefined;
  address?: string | undefined;
  isValid?: string | undefined;
  vatNumber?: string | undefined;
  requestDate?: string | undefined;
  errorMessage?: string | undefined;
  validationStatus?: string | undefined;
}

export interface UserModel {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  latestLoginDate: string | null;
  latestLoginCompanyId: string | null;
  isLockedOut: boolean;
  impersonatedBy: string | null;
  roles: RoleModel[];
  memberships: MembershipModel[];
  acceptsNewTermsOfConditionsDate?: Date | undefined;
}

export interface LoginModel {
  userName: string;
  password: string;
}

export interface LoginAsModel {
  userName: string;
}

export interface RegisterModel {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword?: string | undefined;
}

export interface UpdateUserNameModel {
  firstName: string;
  lastName: string;
}

export interface UpdateUserEmailModel {
  currentEmail: string;
  newEmail: string;
  verificationCode: string;
}

export interface ConfirmEmailModel {
  userId: string;
  token: string;
}

export interface SendConfirmEmailModel {
  email: string;
}

export interface ForgotPasswordModel {
  email: string;
}

export interface ResetPasswordModel {
  userName: string;
  password: string;
  confirmPassword: string;
  token: string;
}
export interface ChangePasswordModel {
  password: string;
  newPassword: string;
  confirmPassword: string;
}
export interface LastLoginCompanyModel {
  companyId: string;
}

export interface ApiCountryModel {
  alpha2Code?: string | undefined;
  name?: string | undefined;
}

export interface CompanyListModel {
  id?: string;
  name?: string | undefined;
  website?: string | undefined;
  email?: string | undefined;
  homeCountryName?: string | undefined;
}

export interface CompanyModel2 {
  id?: string;
  name?: string | undefined;
  abbreviation?: string | undefined;
  website?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  address?: AddressModel2 | undefined;
  companySize?: CompanySize;
  verifierType?: VerifierType;
  accreditedBy?: string | undefined;
  vat?: string | undefined;
  developerType?: DeveloperType;
  hasToolVerificationType?: boolean;
  hasEPDProcessCertification?: boolean;
  archived?: boolean;
  automaticInvoicing?: boolean;
  emailNotifications?: boolean;
  adminNotes?: string | undefined;
  roles?: RoleModel2[] | undefined;
  isGlobalMarketplace: boolean;
  countries?: CountryModel3[] | undefined;
  parentCompany?: LinkedCompanyModel | undefined;
  childCompanies?: LinkedCompanyModel[] | undefined;
  isCompanyCountryInLicensee?: boolean | undefined;
  isExcludedFromAutoDepublish?: boolean | undefined;
  isExcludedFromAutoDeregistration?: boolean | undefined;
  region?: RegionModel;
  hideOnPortal?: boolean;
}

export interface AddressModel2 {
  line1?: string | undefined;
  line2?: string | undefined;
  line3?: string | undefined;
  line4?: string | undefined;
  country?: CountryModel3 | undefined;
  region?: RegionModel;
}

export interface CountryModel3 {
  id?: string | undefined;
  name?: string | undefined;
  alpha2Code?: string | undefined;
}

export interface RoleModel2 {
  id?: string;
  name?: string | undefined;
}

export interface UpdateCompanyModel2 {
  id?: string;
  name?: string | undefined;
  abbreviation?: string | undefined;
  website?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  address?: AddressModel2 | undefined;
  companySize?: CompanySize;
  verifierType?: VerifierType;
  hasToolVerificationType?: boolean;
  hasEPDProcessCertification?: boolean;
  archived?: boolean;
  automaticInvoicing?: boolean;
  emailNotifications?: boolean;
  adminNotes?: string | undefined;
  roles?: RoleModel2[] | undefined;
  countries?: CountryModel3[] | undefined;
  hideOnPortal?: boolean;
  isExcludedFromAutoDeregistration?: boolean | undefined;
}

export interface MoveEPDModel {
  epdId?: string;
  toAccountId?: string;
}

export interface InvoiceListModel {
  id?: string;
  period?: string | undefined;
  companyName?: string | undefined;
  invoiceStatus?: InvoiceStatus;
  sentDate?: Date | undefined;
  invoiceDate?: Date | undefined;
  dueDate?: Date | undefined;
  lateDays?: number | undefined;
}

export interface UploadDocumentTypesModel {
  id: string;
  name: string;
}

export interface InvoiceModel2 {
  id?: string;
  vismaId?: number;
  customerNumber?: string | undefined;
  period?: string | undefined;
  fromDate?: Date;
  toDate?: Date;
  subTotal?: number;
  totalVAT?: number;
  roundOff?: number;
  totalAmount?: number;
  currency?: string | undefined;
  companyName?: string | undefined;
  accountName?: string | undefined;
  reference?: string | undefined;
  invoicingAddress?: AddressModel2 | undefined;
  invoicingEmail?: string | undefined;
  invoicingNotes?: string | undefined;
  invoiceStatus?: InvoiceStatus;
  vat?: string | undefined;
  invoiceDate?: Date | undefined;
  dueDate?: Date | undefined;
  termsOfPayment?: string | undefined;
  ourReference?: string | undefined;
  invoiceItems?: InvoiceItemModel2[] | undefined;
}

export interface InvoiceItemModel2 {
  id?: string;
  code?: string | undefined;
  description?: string | undefined;
  hasVAT?: boolean;
  amount?: number | undefined;
}

export interface UpdateInvoiceModel {
  id?: string;
  companyName?: string | undefined;
  accountName?: string | undefined;
  customerNumber?: string | undefined;
  vat?: string | undefined;
  reference?: string | undefined;
  invoicingAddress?: AddressModel2 | undefined;
  invoiceStatus?: InvoiceStatus;
}

export interface CreateInvoiceModel {
  accountId?: string;
  period?: string | undefined;
}

export interface KPIModel {
  title?: string | undefined;
  description?: string | undefined;
  kpIs?: KeyValuePairOfStringAndInteger[] | undefined;
}

export interface KeyValuePairOfStringAndInteger {
  key?: string;
  value?: number;
}

export interface PCRModel2 {
  version?: string | undefined;
  versionDate?: Date | undefined;
  id?: string;
  isBasicModule?: boolean;
  registrationNumber?: string | undefined;
  status?: PCRStatus;
  initiatedDate?: Date | undefined;
  startOpenConsultationDate?: Date | undefined;
  deadlineOpenConsultationDate?: Date | undefined;
  reviewAndApprovalDate?: Date | undefined;
  publicationDate?: Date | undefined;
  showUpdateInfoUntil?: Date | undefined;
  approvalDate?: Date | undefined;
  deregistrationDate?: Date | undefined;
  validUntil?: string | undefined;
  is15804Compliant?: boolean;
  isISO219302017Available?: boolean;
  isEN158042012A2Available?: boolean;
  isVisibleForCompiler?: boolean;
  isComplementary?: boolean;
  friendlyUrl?: string | undefined;
  languageCode?: string | undefined;
  name?: string | undefined;
  fullName?: string | undefined;
  shortName?: string | undefined;
  combinedName?: string | undefined;
  cpcName?: string | undefined;
  pcrReviewPanel?: string | undefined;
  chairOfThePCRReview?: string | undefined;
  text?: string | undefined;
  statusText?: string | undefined;
  description?: string | undefined;
  legalNote?: string | undefined;
  keywords?: string | undefined;
  preparedBy?: string | undefined;
  contributors?: string | undefined;
  fileId?: string;
  documents?: FileModel2[] | undefined;
  cpCs?: CPCModel2[] | undefined;
  productCategories?: ProductCategoryModel2[] | undefined;
  cpcrProductCategories?: ProductCategoryModel2[] | undefined;
}

export interface FileModel2 {
  id?: string;
  name?: string | undefined;
  isRemovable?: boolean;
}

export interface CPCModel2 {
  id?: string;
  code?: string | undefined;
  description?: string | undefined;
}

export interface ProductCategoryModel2 {
  id?: string;
  title?: string | undefined;
}

export interface PreverifiedToolModel2 {
  id?: string | undefined;
  name?: string | undefined;
}

export interface CreatePCRModel2 {
  name?: string | undefined;
}

export interface UpdatePCRModel2 {
  id?: string;
  name?: string | undefined;
}

export interface UserListModel {
  id?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
}

export interface UserModel2 {
  id?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  archived?: boolean;
  hideOnPortal?: boolean;
}

export interface UpdateUserModel {
  id?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  archived?: boolean;
  hideOnPortal?: boolean;
}

export interface SetUserPasswordModel {
  id?: string;
  password?: string | undefined;
  confirmPassword?: string | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export enum DataQualityAssessmentItemEnum {
  ProcessName = 'processName',
  SourceType = 'sourceType',
  Source = 'source',
  ReferenceYear = 'referenceYear',
  DataCategory = 'dataCategory',
  ShareOfPrimaryData = 'shareOfPrimaryData',
}

export enum TypeOfBiogasMixEnum {
  InternallyGenerated = '1',
  GasFromGrid = '2',
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

export interface EPDILCDRelationModel {
  id: string;
  ilcduuid: string | undefined;
  epdilcdRelationId: string | undefined;
  epdVersionId: string | undefined;
  epdId: string | undefined;
  environdecObjectName: string | undefined;
  ilcdVersion: string | undefined;
  environdecType: string | undefined;
  ilcdPlusEPDType: string | undefined;
  log: string | undefined;
  publishedToEcoplatform: string | undefined;
  companyName: string | undefined;
}

export interface EPDILCDRelation {
  id: string;
  ilcduuid: string | undefined;
  epdilcdRelationId: string | undefined;
  epdVersionId: string | undefined;
  ilcdVersion: string | undefined;
  environdecObjectName: string;
  iLCDType: string;
  environdecType: string;
  log: string | undefined;
  publishedToEcoplatform: string | undefined;
}

export interface FortnoxSettingsModel {
  clientId: string;
  redirectURL: string | undefined;
  state: string | undefined;
  refreshTokenDateTime: string | undefined;
}

export interface FortnoxLogs {
  dateTimeUTC: string | undefined;
  actionType: string | undefined;
  actionStage: string | undefined;
  typeIdObject: string | undefined;
  idObject: string | undefined;
  text: string | undefined;
  notes: string | undefined;
}

export interface FortnoxAuthorizationCodeModel {
  code: string;
  state: string | undefined;
}

export interface EPDRelationsListModel {
  epdId: string;
  epdVersionId: string;
  hasCreatedRelation: string;
  isPublishedOnPortal: string;
  relationId: string | undefined;
  ilcdVersion: string | undefined;
  ilcduuid: string | undefined;
  wasPublishedOnSODA: string;
  actionText: string;
}

export interface FindEPDILCDRelationsPagedModel {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  items: EPDILCDRelationModel[];
}

export interface EPDRelationsListPagedModel {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  items: EPDRelationsListModel[];
}

export interface UploadDataArchiveModel {
  environdecType: string;
  ilcdType: string;
  version: string;
}

export interface UpdateEPDILCDRelationModel {
  epdilcdRelationId: string;
  ilcdVersion: string | undefined;
  ilcdPlusEPDType: string | undefined;
  environdecType: string | undefined;
}

export interface FileLoadingModel {
  fileType: string;
  loadingsCount: number;
}

export interface OkobaudatProductCategoryModel {
  id: string;
  nameEn: string;
  number: string;
  parentCategoryId: string | null;
  children: OkobaudatProductCategoryModel[] | null;
}

export interface FindEPDsToCopyModel {
  accountId?: string | null;
  companyId?: string | null;
  copyGroupId?: string | null;
}

export interface UserAffiliatedCompanyModel {
  id: string;
  name: string;
  roles: RoleModel[];
  isUserAccountManager: boolean;
  isUserVerifierInHomeCompany: boolean;
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

export interface IAdminIntegrationsClient {
  find(
    name: string | null | undefined,
    ilcdType: string | null | undefined,
    environdecType: string | null | undefined,
    pageNumber: number,
    pageSize: number
  ): Promise<FindEPDILCDRelationsPagedModel>;
  create(epdVersionId: string): Promise<EPDILCDRelationModel>;
  get(id: string): Promise<EPDILCDRelationModel>;
  update(id: string, updateModel: UpdateEPDILCDRelationModel): Promise<EPDILCDRelationModel>;
  publish(id: string): Promise<boolean>;
  depublish(id: string): Promise<boolean>;
  uploadIlcdEpdDataArchive(id: string): Promise<boolean>;
}

export interface RemoveUserRolesModel {
  roleIds: string[];
}

export type UserRoleNames = 'Admin' | 'LicenseeAdmin' | 'Practitioner' | 'Verifier' | 'Owner' | 'Unknown';

export class AdminIntegrationsClient extends BaseClient implements IAdminIntegrationsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  find(
    name: string | null | undefined,
    ilcdType: string | null | undefined,
    environdecType: string | null | undefined,
    pageNumber: number = 1,
    pageSize: number = 10
  ): Promise<FindEPDILCDRelationsPagedModel> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/find?';
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    if (ilcdType !== undefined && ilcdType !== null) url_ += 'ilcdType=' + encodeURIComponent('' + ilcdType) + '&';
    if (environdecType !== undefined && environdecType !== null)
      url_ += 'environdecType=' + encodeURIComponent('' + environdecType) + '&';
    if (pageNumber !== undefined && pageNumber !== null) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize !== undefined && pageSize !== null) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processFind(_response);
      });
  }

  protected processFind(response: Response): Promise<FindEPDILCDRelationsPagedModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <FindEPDILCDRelationsPagedModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FindEPDILCDRelationsPagedModel>(<any>null);
  }

  get(id: string): Promise<EPDILCDRelationModel> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: Response): Promise<EPDILCDRelationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CountryModel3[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDILCDRelationModel>(<any>null);
  }

  publish(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/publish/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublish(_response);
      });
  }

  protected processPublish(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return Promise.resolve<boolean>(true);
    } else if (status === 409) {
      return Promise.resolve<boolean>(false);
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(false);
  }

  depublish(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/depublish/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDepublish(_response);
      });
  }

  protected processDepublish(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return Promise.resolve<boolean>(true);
    } else if (status === 409) {
      return Promise.resolve<boolean>(false);
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(false);
  }

  uploadIlcdEpdDataArchive(id: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/upload/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUploadIlcdEpdDataArchive(_response);
      });
  }

  protected processUploadIlcdEpdDataArchive(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return Promise.resolve<boolean>(true);
    } else if (status === 409) {
      return Promise.resolve<boolean>(false);
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(false);
  }

  create(epdVersionId: string): Promise<EPDILCDRelationModel> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/relation';
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify({ epdVersionId: epdVersionId });
    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: Response): Promise<EPDILCDRelationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 = _responseText === '' ? null : <EPDILCDRelationModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDILCDRelationModel>(<any>null);
  }

  update(id: string, updateModel: UpdateEPDILCDRelationModel): Promise<EPDILCDRelationModel> {
    let url_ = this.baseUrl + '/api/v1/EPDILCDIntegrations/relation/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateModel);

    let options_ = this.getPutOptionsNoAccept(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPut(_response);
      });
  }

  protected processPut(response: Response): Promise<EPDILCDRelationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 = _responseText === '' ? null : <EPDILCDRelationModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result204;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === '' ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === '' ? null : <ModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EPDILCDRelationModel>(<any>null);
  }
}

export interface IFortnoxIntegrationsClient {
  send(id: string): Promise<void>;
  getFortnoxSettings(): Promise<FortnoxSettingsModel>;
  updateAuthCode(code: string, state: string): Promise<void>;
  pushAllCompaniesToFortnox(): Promise<string>;
  generateNewTokens(code: string): Promise<void>;
  getLastLogs(): Promise<FortnoxLogs[]>;
}

export class FortnoxIntegrationsClient extends BaseClient implements IFortnoxIntegrationsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  async send(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/fortnox/company/{id}/send/A3CFE043-4F7E-4E7E-A5CE-FBA8B563A2A6';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify('');

    let options_ = this.getPutOptionsNoAccept(content_);
    const response = await this.http.fetch(url_, await this.transformOptions(options_));
    if (!response.ok) {
      return throwException('A server side error occurred.', response.status, await response.text(), {});
    }
  }

  protected processSend(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        return _responseText;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result: any = null;
        return throwException(_responseText, status, _responseText, _headers, result);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result: any = null;
        return throwException(_responseText, status, _responseText, _headers, result);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result: any = null;
        return throwException(_responseText, status, _responseText, _headers, result);
      });
    } else if (status !== 200 && status !== 204 && status !== 201) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  getFortnoxSettings(): Promise<FortnoxSettingsModel> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/settings';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<FortnoxSettingsModel>(_response);
      });
  }

  getLastLogs(): Promise<FortnoxLogs[]> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/logs';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<FortnoxLogs[]>(_response);
      });
  }

  createInvoices(from: Date, to: Date): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/CreateInvoice';
    url_ = url_.replace(/[?&]$/, '');

    if (to === null || to === undefined) {
      throw new Error("The parameter 'to' cannot be null.");
    }
    if (from === null || from === undefined) {
      throw new Error("The parameter 'from' cannot be null.");
    }

    const content_ = JSON.stringify({ From: from, To: to });

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  createInvoiceForSpecificCompany(from: Date, to: Date, companyId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/CreateInvoice/{companyId}';
    url_ = url_.replace('{companyId}', encodeURIComponent('' + companyId));
    url_ = url_.replace(/[?&]$/, '');

    if (companyId === null || companyId === undefined) {
      throw new Error("The parameter 'companyId' cannot be null.");
    }
    if (to === null || to === undefined) {
      throw new Error("The parameter 'to' cannot be null.");
    }
    if (from === null || from === undefined) {
      throw new Error("The parameter 'from' cannot be null.");
    }

    const content_ = JSON.stringify({ From: from, To: to, companyId: companyId });

    let options_ = this.getPostOptions(content_);

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  updateAuthCode(code: string, state: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/updateauthcode';
    url_ = url_.replace(/[?&]$/, '');

    if (code === null || code === undefined) {
      throw new Error("The parameter 'code' cannot be null.");
    }
    if (state === null || state === undefined) {
      throw new Error("The parameter 'state' cannot be null.");
    }

    const content_ = JSON.stringify({ code: code, state: state });
    let options_ = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response) => {
        return this.baseProcessUpdate(_response);
      });
  }

  pushAllCompaniesToFortnox(): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/Fortnox/company/fullCustomerUpdate/A3CFE043-4F7E-4E7E-A5CE-FBA8B563A2A6';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGet<string>(_response);
      });
  }

  generateNewTokens(code: string): Promise<void> {
    let url_ = this.baseUrl + `/api/v1/Fortnox/GenerateNewToken/${code}`;
    if (code === undefined || !code) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.baseProcessUpdate(_response);
      });
  }
}

export interface IVatValidationClient {
  get(vat: string): Promise<VatValidation>;
}

export class VatValidationClient extends BaseClient implements IVatValidationClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost:44380';
  }

  get(vat: string): Promise<VatValidation> {
    let url_ = this.baseUrl + '/api/VatValidation/{vat}';
    url_ = url_.replace('{vat}', encodeURIComponent('' + vat));
    url_ = url_.replace(/[?&]$/, '');
    let options_ = this.getOptions();

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.genericProcessGetAll<VatValidation>(_response);
      });
  }
}

export default BaseClient;
